/* eslint-disable tailwindcss/no-custom-classname */

export type IconType =
    | 'logo'
    | 'square-logo'
    | 'crow-icon'
    | 'checkmark'
    | 'magnifying_glass'
    | 'pencil'
    | 'trash'
    | 'plus'
    | 'upload'
    | 'shapes'
    | 'x'
    | 'menu'
    | '3-dot-menu'
    | 'eye'
    | 'info'
    | 'analytics'
    | 'configure-experiment'
    | 'open'
    | 'image'
    | 'header'
    | 'video-carousel'
    | 'product'
    | 'upsell'
    | 'rename'
    | 'archive'
    | 'unarchive'
    | 'video'
    | 'pages'
    | 'embed'
    | 'graph'
    | 'bar-chart'
    | 'team'
    | 'gear'
    | 'paintbrush'
    | 'code'
    | 'collection'
    | 'undo'
    | 'redo'
    | 'chevron-down'
    | 'chevron-up'
    | 'header-one'
    | 'header-two'
    | 'header-three'
    | 'paragraph'
    | 'list-bullet'
    | 'list-numbered'
    | 'bold'
    | 'italic'
    | 'underline'
    | 'link'
    | 'collapse'
    | 'inline-content'
    | 'review-stars'
    | 'plp-grid'
    | 'personalized-plp-grid'
    | 'support-center'
    | 'wrench'
    | 'post-click-explorer'
    | 'house'
    | 'email'
    | 'advertising'
    | 'credit-card'
    | 'google'

type IconProps = {
    type: IconType
    color: string
    transform?: string
    height?: number
    width?: number
}

type IndividualIconProps = {
    color: string
    transform?: string
    height?: number
    width?: number
}

export const MagicIcon = ({ color, height, width }: IndividualIconProps) => {
    return (
        <svg
            fill={color}
            width={width}
            height={height}
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: 'scaleX(-1)' }}
        >
            <title>magic</title>
            <path
                fill={color}
                d="M9.5 9.625l-0.906 2.906-0.875-2.906-2.906-0.906 2.906-0.875 0.875-2.938 0.906 2.938 2.906 0.875zM14.563 8.031l-0.438 1.469-0.5-1.469-1.438-0.469 1.438-0.438 0.5-1.438 0.438 1.438 1.438 0.438zM0.281 24l17.906-17.375c0.125-0.156 0.313-0.25 0.531-0.25 0.281-0.031 0.563 0.063 0.781 0.281 0.094 0.063 0.219 0.188 0.406 0.344 0.344 0.313 0.719 0.688 1 1.063 0.125 0.188 0.188 0.344 0.188 0.5 0.031 0.313-0.063 0.594-0.25 0.781l-17.906 17.438c-0.156 0.156-0.344 0.219-0.563 0.25-0.281 0.031-0.563-0.063-0.781-0.281-0.094-0.094-0.219-0.188-0.406-0.375-0.344-0.281-0.719-0.656-0.969-1.063-0.125-0.188-0.188-0.375-0.219-0.531-0.031-0.313 0.063-0.563 0.281-0.781zM14.656 11.375l1.313 1.344 4.156-4.031-1.313-1.375zM5.938 13.156l-0.406 1.438-0.438-1.438-1.438-0.469 1.438-0.438 0.438-1.469 0.406 1.469 1.5 0.438zM20.5 12.063l0.469 1.469 1.438 0.438-1.438 0.469-0.469 1.438-0.469-1.438-1.438-0.469 1.438-0.438z"
            ></path>
        </svg>
    )
}

export const UploadIcon = ({ color, height, width }: IndividualIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title />
            <g id="Complete">
                <g id="upload">
                    <g>
                        <path
                            d="M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7"
                            fill="none"
                            stroke={color || '#000000'}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                        />
                        <g>
                            <polyline
                                data-name="Right"
                                fill="none"
                                id="Right-2"
                                points="7.9 6.7 12 2.7 16.1 6.7"
                                stroke={color || '#000000'}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                            />
                            <line
                                fill="none"
                                stroke={color || '#000000'}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                x1="12"
                                x2="12"
                                y1="16.3"
                                y2="4.8"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export const InstagramLogo = ({ height, width }: IndividualIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
                fill="#0F0F0F"
            />
            <path
                d="M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z"
                fill="#0F0F0F"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z"
                fill="#0F0F0F"
            />
        </svg>
    )
}

export const TikTokLogo = ({ height, width }: IndividualIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16.8218 5.1344C16.0887 4.29394 15.648 3.19805 15.648 2H14.7293C14.9659 3.3095 15.7454 4.43326 16.8218 5.1344Z"
                fill="#000000"
            />
            <path
                d="M8.3218 11.9048C6.73038 11.9048 5.43591 13.2004 5.43591 14.7931C5.43591 15.903 6.06691 16.8688 6.98556 17.3517C6.64223 16.8781 6.43808 16.2977 6.43808 15.6661C6.43808 14.0734 7.73255 12.7778 9.324 12.7778C9.62093 12.7778 9.90856 12.8288 10.1777 12.9124V9.40192C9.89927 9.36473 9.61628 9.34149 9.324 9.34149C9.27294 9.34149 9.22654 9.34614 9.1755 9.34614V12.0394C8.90176 11.9558 8.61873 11.9048 8.3218 11.9048Z"
                fill="#000000"
            />
            <path
                d="M19.4245 6.67608V9.34614C17.6429 9.34614 15.9912 8.77501 14.6456 7.80911V14.7977C14.6456 18.2851 11.8108 21.127 8.32172 21.127C6.97621 21.127 5.7235 20.6998 4.69812 19.98C5.8534 21.2198 7.50049 22 9.32392 22C12.8083 22 15.6478 19.1627 15.6478 15.6707V8.68211C16.9933 9.64801 18.645 10.2191 20.4267 10.2191V6.78293C20.0787 6.78293 19.7446 6.74574 19.4245 6.67608Z"
                fill="#000000"
            />
            <path
                d="M14.6456 14.7977V7.80911C15.9912 8.77501 17.6429 9.34614 19.4245 9.34614V6.67608C18.3945 6.45788 17.4899 5.90063 16.8218 5.1344C15.7454 4.43326 14.9704 3.3095 14.7245 2H12.2098L12.2051 15.7775C12.1495 17.3192 10.8782 18.5591 9.32393 18.5591C8.35884 18.5591 7.50977 18.0808 6.98085 17.3564C6.06219 16.8688 5.4312 15.9076 5.4312 14.7977C5.4312 13.205 6.72567 11.9094 8.31708 11.9094C8.61402 11.9094 8.90168 11.9605 9.17079 12.0441V9.35079C5.75598 9.42509 3 12.2298 3 15.6707C3 17.3331 3.64492 18.847 4.69812 19.98C5.7235 20.6998 6.97621 21.127 8.32172 21.127C11.8061 21.127 14.6456 18.2851 14.6456 14.7977Z"
                fill="#000000"
            />
        </svg>
    )
}

export const Arrow = ({
    color,
    transform,
    height,
    width,
}: IndividualIconProps) => {
    return (
        <svg
            style={{ transform: transform }}
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.2929 4.29289C12.6834 3.90237 13.3166 3.90237 13.7071 4.29289L20.7071 11.2929C21.0976 11.6834 21.0976 12.3166 20.7071 12.7071L13.7071 19.7071C13.3166 20.0976 12.6834 20.0976 12.2929 19.7071C11.9024 19.3166 11.9024 18.6834 12.2929 18.2929L17.5858 13H4C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11H17.5858L12.2929 5.70711C11.9024 5.31658 11.9024 4.68342 12.2929 4.29289Z"
                fill={color}
            />
        </svg>
    )
}

export const MutedIcon = ({ color, height, width }: IndividualIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 -1 24 24"
            id="meteor-icon-kit__solid-volume-mute"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.29292 20.2929C0.902398 20.6834 0.902398 21.3166 1.29292 21.7071C1.68345 22.0976 2.31661 22.0976 2.70714 21.7071L3.69966 20.7146C3.70215 20.7121 3.70463 20.7097 3.70711 20.7072L21.7071 2.70721C21.7096 2.70475 21.712 2.70227 21.7145 2.69979L22.7071 1.70711C23.0977 1.31658 23.0977 0.68342 22.7071 0.29289C22.3166 -0.097631 21.6834 -0.097631 21.2929 0.29289L13.5 8.08581V2.30132C13.5 0.55256 11.4138 -0.353996 10.1354 0.83921L4.60584 6.00011H1C0.447715 6.00011 0 6.44783 0 7.00011V15.0001C0 15.5524 0.447715 16.0001 1 16.0001H4.60584L5.11266 16.4732L1.29292 20.2929z"
                fill={color}
            />
            <path
                d="M8.02396 19.1904L13.5 13.7143V19.6989C13.5 21.4477 11.4138 22.3542 10.1354 21.161L8.02396 19.1904z"
                fill={color}
            />
            <path
                d="M17.7563 9.4581L19.2887 7.92564C19.7574 8.88434 20.0016 9.9396 20 11.0109C19.9981 12.2415 19.6718 13.4498 19.0541 14.5141C18.4363 15.5784 17.5489 16.4611 16.4813 17.0731C16.0021 17.3477 15.391 17.182 15.1164 16.7028C14.8417 16.2237 15.0075 15.6126 15.4866 15.3379C16.2492 14.9008 16.8831 14.2703 17.3243 13.5101C17.7656 12.7499 17.9986 11.8868 18 11.0078C18.0008 10.4795 17.9179 9.9566 17.7563 9.4581z"
                fill={color}
            />
            <path
                d="M20.7648 6.44952L20.7977 6.50611C21.5877 7.87694 22.0024 9.4318 22 11.014C21.9975 12.5962 21.578 14.1498 20.7838 15.5181C19.9895 16.8865 18.8485 18.0213 17.4759 18.8082C16.9968 19.0828 16.831 19.6939 17.1057 20.1731C17.3803 20.6522 17.9914 20.818 18.4705 20.5433C20.1482 19.5816 21.5427 18.1946 22.5135 16.5221C23.4843 14.8497 23.997 12.9509 24 11.0171C24.003 9.0833 23.4961 7.1829 22.5305 5.50745C22.4306 5.33417 22.3262 5.16393 22.2174 4.99688L20.7648 6.44952z"
                fill={color}
            />
        </svg>
    )
}

export const UnmutedIcon = ({ color, height, width }: IndividualIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            id="meteor-icon-kit__solid-volume-up"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_525_159)">
                <path
                    d="M13.5 3.30132C13.5 1.55256 11.4138 0.646005 10.1354 1.83922L4.60584 7.00011H1C0.447715 7.00011 0 7.44783 0 8.00011V16.0001C0 16.5524 0.447715 17.0001 1 17.0001H4.60584L10.1354 22.161C11.4138 23.3542 13.5 22.4477 13.5 20.6989V3.30132Z"
                    fill={color}
                />
                <path
                    d="M15.1164 17.7028C14.8417 17.2237 15.0075 16.6126 15.4866 16.3379C16.2492 15.9008 16.8831 15.2703 17.3243 14.5101C17.7656 13.7499 17.9986 12.8868 18 12.0078C18.0013 11.1288 17.771 10.265 17.3321 9.50346C16.8931 8.74189 16.2612 8.10948 15.5 7.66998C15.0217 7.39384 14.8578 6.78225 15.134 6.30396C15.4101 5.82567 16.0217 5.66179 16.5 5.93793C17.5657 6.55323 18.4504 7.4386 19.0649 8.50479C19.6793 9.57099 20.0019 10.7803 20 12.0109C19.9981 13.2415 19.6718 14.4498 19.0541 15.5141C18.4363 16.5784 17.5489 17.4611 16.4813 18.0731C16.0021 18.3477 15.391 18.182 15.1164 17.7028Z"
                    fill={color}
                />
                <path
                    d="M17.4759 19.8082C16.9968 20.0828 16.831 20.6939 17.1057 21.1731C17.3803 21.6522 17.9914 21.818 18.4706 21.5433C20.1482 20.5816 21.5428 19.1946 22.5135 17.5221C23.4843 15.8497 23.997 13.9509 24 12.0171C24.003 10.0833 23.4961 8.1829 22.5305 6.50745C21.5649 4.832 20.1747 3.44071 18.5 2.47382C18.0217 2.19767 17.4101 2.36155 17.134 2.83984C16.8578 3.31813 17.0217 3.92972 17.5 4.20587C18.8702 4.99696 20.0077 6.13529 20.7977 7.50611C21.5877 8.87694 22.0024 10.4318 22 12.014C21.9976 13.5962 21.5781 15.1498 20.7838 16.5181C19.9895 17.8865 18.8486 19.0213 17.4759 19.8082Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_525_159">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export const WrenchIcon = ({ color, height, width }: IndividualIconProps) => {
    return (
        <svg
            width={width || 14}
            height={height || 14}
            viewBox="0 0 442.037 442.037"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M292.076,224.047l59.896-59.896c9.69-9.692,21.926-17.104,35.381-21.433c10.86-3.491,20.9-9.63,29.04-17.758 c14.023-14.03,21.573-32.683,21.258-52.524c-0.314-19.836-8.469-38.252-22.96-51.856l-8.728-8.193L390.1,63.242 c-3.501,11.209-15.475,17.488-26.686,13.996c-8.951-2.795-14.966-10.969-14.966-20.341c0-2.151,0.326-4.285,0.97-6.346L365.193,0 l-11.976,1.945c-13.45,2.184-25.93,8.055-36.093,16.982c-17.856,15.711-26.943,39.167-24.31,62.743 c2.854,25.591-6.265,51.031-25.019,69.794l-24.156,24.148l-43.87-43.87l13.494-13.494l-26.551-26.551 c14.251-20.992,46.044-49.593,75.545-62.687l13.351-5.926l-12.596-7.396C226.284-5.88,179.234,0.458,148.591,31.102 c-2.521,2.521-78.083,78.083-78.083,78.083l-5.25,5.25l5.197,5.303c4.561,4.652,2.924,14.072-3.575,20.571 c-6.499,6.498-15.92,8.135-20.57,3.575l-5.303-5.197L0.502,179.191L76.41,255.1l40.483-40.483l-5.152-5.302 c-4.525-4.656-2.875-14.063,3.604-20.542c6.478-6.479,15.884-8.129,20.541-3.604l5.302,5.153l12.69-12.69l43.87,43.87 l-56.385,56.386c-9.681,9.689-21.912,17.1-35.37,21.431c-11.022,3.543-20.792,9.521-29.038,17.767 c-14.024,14.025-21.576,32.672-21.264,52.507c0.313,19.837,8.468,38.256,22.963,51.864l8.728,8.193l15.868-50.852 c1.69-5.432,5.397-9.878,10.438-12.521c5.04-2.643,10.805-3.165,16.24-1.468c8.954,2.789,14.971,10.955,14.971,20.319 c0,2.129-0.33,4.27-0.98,6.358l-15.76,50.551l11.974-1.946c13.454-2.187,25.933-8.058,36.091-16.982 c17.856-15.711,26.943-39.167,24.31-62.742c-2.854-25.592,6.265-51.032,25.021-69.795l20.633-20.633l139.969,139.969 c6.327,6.327,14.635,9.489,22.945,9.489c8.309-0.001,16.62-3.164,22.946-9.489c12.651-12.652,12.651-33.238,0-45.89L292.076,224.047z"
                stroke={color || 'currentColor'}
                strokeWidth="15"
                fill="none"
            />
        </svg>
    )
}

// eslint-disable-next-line complexity
export const Icon: React.FunctionComponent<IconProps> = ({
    type,
    color,
    transform,
    width,
    height,
}) => {
    switch (type) {
        case 'wrench':
            return <WrenchIcon color={color} height={height} width={width} />
        case 'logo':
            return (
                <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 2238.5 346.1"
                    style={{ fill: color || '#FFFFFF' }}
                >
                    <path
                        fill={color || '#FFFFFF'}
                        d="M2119.6,126.2l29-75.4l2.8-7.7h19.3l32.1,83.9l4.9,12.8h-21.6l-4.2-12.8l-3.2-9.4h-36.3l-3.2,9.3l-4.3,12.9
                        h-20.4L2119.6,126.2L2119.6,126.2z M2174.1,103.9l-13.4-39.5l-13.5,39.5H2174.1z M2218.3,43.2h20.2v96.7h-20.2V43.2L2218.3,43.2z
                        M597.2,304.2v-1.3c-11.7-8.1-13.3-19.8-13.3-43.5V87.4c0-26.5,0.7-34.1,2.3-44.2l-0.4-1.3l-48.5,5.7v1.3
                        c10,7.7,12.4,18.4,12.4,38.5v171.8c0,23.8-1.7,35.5-14,43.5v1.4L597.2,304.2L597.2,304.2L597.2,304.2z M667.6,308.5
                        c33,0,49.1-10.3,63-31.2c0.9-1.3,2.4-2.1,4-2c2.2,0.1,4,1.6,4,4.2c0,17.2,12,27.3,26.6,27.3c25.5,0,27.1-22.8,27.1-22.8
                        c-3.7,3-7.3,4.4-12,4.4c-10,0-15.7-7.4-15.7-26.1v-72.6c0-40.5-27.4-55.2-61.8-55.2c-39.8,0-78.6,20.8-81.3,59.6h32
                        c5.4,0,9.7-4.4,10.3-9.8c2.9-24.4,16-34.4,35.9-34.4s31.8,9.4,31.8,27.2c-0.3,21.3-15.8,25.8-46.8,34.6l-0.6,0.2
                        c-41.4,12.1-65.2,23.1-65.2,53.6c0,28.8,20.4,43.2,48.8,43.2h-0.1L667.6,308.5L667.6,308.5L667.6,308.5z M651.8,261
                        c0-19.8,14.1-27.1,40.8-35.8c20.3-6.7,34.1-11.4,38.8-22.1v15.8c0,40.2-21.8,68.3-53.2,68.3C663.9,287.1,651.8,279.4,651.8,261
                        L651.8,261L651.8,261L651.8,261L651.8,261z M882.1,309.9c48.1,0,75.8-31.5,81.9-72.6h-18.4c-6,29.8-23.4,51.9-55.8,51.9
                        c-38.8,0-53.2-32.5-53.2-71.7s14.5-67,48.9-67c27.6,0,40,18.6,45.1,38.3c1.2,4.7,5.3,8.2,10.1,8.2h22
                        c-4.7-34.5-32.8-62.3-77.9-62.3c-48.5,0-87.7,32.1-87.7,87.7S834.3,309.9,882.1,309.9L882.1,309.9z M1371.3,308.9
                        c70.5,0,117-43.5,127.4-112.2h-21.8c-9,52.6-44.1,87.4-98.6,87.4c-63.8,0-93.4-49.6-93.4-110.5s32.2-108.9,89.3-108.9
                        c41.9,0,71.3,25.6,83.3,66.4c1.3,4.4,5.2,7.6,9.8,7.6h28.9c-14.3-61.3-62.5-91.8-122-91.8c-77.6,0-133.2,52.6-133.2,131.3
                        C1241.1,251.3,1290.4,309,1371.3,308.9L1371.3,308.9L1371.3,308.9L1371.3,308.9L1371.3,308.9z M1728.9,309.9
                        c52.8,0,88.1-35.5,88.1-87.7s-35.2-87.4-88.1-87.4s-88.1,34.8-88.1,87.4S1676.4,309.9,1728.9,309.9z M1678.2,222.2
                        c0-45.5,17.9-71.7,51-71.7s50.3,26.1,50.3,71.7s-17.9,72-50.3,72S1678.2,267.4,1678.2,222.2z M1839.1,172.6l46.5,131.7h25.7
                        c0.7-5.4,2-9.7,5-18.7l31.1-99.5l37.7,118.3h25.3c0.6-5,2-9,3.9-14.6l0.4-1.1l0.3-0.8l0.2-0.6l40.8-115.6
                        c5.7-16.8,11-24.8,19-30.1v-1h-45.1v1c10,3.7,9.3,13.4,3.7,29.8l-31.4,94.4l-37.8-118.6h-19.4L1908,265.5l-32.1-94.8
                        c-5.3-16.1-6-25.1,4-29.1v-1h-61.1v1c9,4.4,13.7,14.4,20.1,31.2L1839.1,172.6L1839.1,172.6L1839.1,172.6z
                        M464.1,170.3c0,0-0.2-0.1-0.4-0.1c-1.6-0.4-5.3-1.3-5.3-5.1c0-3.4,2.9-4.7,4.9-5.4c28.5-10.5,41.2-24.3,41.2-51.5
                        c0-40.5-41.7-57.6-98.2-57.6h-87.9v1c13,8.4,14.7,18.7,14.7,43.9v163.9c0,23.8-1.7,35.5-14.7,43.5v1.3h89.9
                        c63.5,0,108.9-22.1,108.9-71.3C517.3,201.1,495.7,178.9,464.1,170.3L464.1,170.3L464.1,170.3z M403.4,67.1
                        c36.8,0,61.8,11.7,61.8,43.5s-25.8,51.3-62.5,51.3h-33.1V67.1L403.4,67.1L403.4,67.1z M406,287.8h-36.5V174.6h33.8
                        c45.2,0,72.5,19.1,72.5,57.3C475.9,273.1,447.1,287.8,406,287.8L406,287.8L406,287.8L406,287.8L406,287.8z M1559.6,185.3
                        c1.6,0.3,3-0.5,3.5-2l0.1,0c9.5-27.5,31.1-44.6,70.9-45v22c0,5.6-4.7,10-10.2,10.2c-40.4,1.7-57.3,23-57.3,51.8v38.2
                        c0,23.5,1.7,34.5,14.7,42.6v1h-62.5v-1.3c11.7-8,13.7-19.7,13.7-43.5v-74c0-25.1-2-35.5-13.7-43.9v-1h52.5c-1,2.1-2.3,4.2-3.8,6.4
                        c-4.7,7.1-10.6,16.3-10.6,35.4C1556.8,183.7,1558,185,1559.6,185.3L1559.6,185.3z M1086.8,227c-6.3-2.1-9.9-3.1-9.9-6.4
                        c0-3.6,3.6-4.8,10-7.5c18.6-8,40.1-22.9,40.1-58.1c0-10.4-0.9-18.1-0.9-18.1h-26.8c-5.9,0-10.8,4.8-10.8,10.6c0,8.8-0.5,15.5-0.7,19
                        c-1.8,29.5-24.9,47.7-56.5,47.7V87.4c0-26.5,0.7-34.5,2.3-44.5l-2.3-1l-45.4,5.7v1.3C995.4,56.6,997,67,997,87.4v171.8
                        c0,23.8-1.7,35.5-14,43.5v1.3h61.8c-12.1-8-13.7-21.1-13.7-44.8v-31.4c38.7,0,66.9,24,70.4,59.1c1.2,12.1,2,17.4,14.3,17.4h24.7
                        c0,0,1.1-8.5,1.1-14.9C1141.6,250,1106.4,233.4,1086.8,227L1086.8,227L1086.8,227z M204.7,171.7c-20-5.6-73.7-32.5-77.3-142.9
                        C126.8,13.1,114.5,0,98.8,0H2c0,0-19.5,90.6,64,137.1c35.2,19.6,64.2,23.8,64.2,35.9s-29,16.3-64.2,35.9
                        C-17.5,255.4,2,346.1,2,346.1h96.8c15.7,0,28-13.1,28.6-28.8c3.7-110.4,57.3-137.3,77.4-142.9c0.6-0.2,1-0.7,1-1.4
                        S205.3,171.9,204.7,171.7L204.7,171.7L204.7,171.7z"
                    />
                </svg>
            )
        case 'checkmark':
            return (
                <svg
                    width={width}
                    height={width}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill={color}
                        d="M22.7048 4.95406C22.3143 4.56353 21.6811 4.56353 21.2906 4.95406L8.72696 17.5177C8.33643 17.9082 7.70327 17.9082 7.31274 17.5177L2.714 12.919C2.32348 12.5284 1.69031 12.5284 1.29979 12.919C0.909266 13.3095 0.909265 13.9427 1.29979 14.3332L5.90392 18.9289C7.07575 20.0986 8.97367 20.0978 10.1445 18.9271L22.7048 6.36827C23.0953 5.97775 23.0953 5.34458 22.7048 4.95406Z"
                    />
                </svg>
            )
        case 'magnifying_glass':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    enableBackground="new 0 0 487.95 487.95"
                    version="1.1"
                    viewBox="0 0 487.95 487.95"
                    xmlSpace="preserve"
                    style={{ transform }}
                >
                    <path
                        fill={color}
                        d="M481.8 453l-140-140.1c27.6-33.1 44.2-75.4 44.2-121.6C386 85.9 299.5.2 193.1.2S0 86 0 191.4s86.5 191.1 192.9 191.1c45.2 0 86.8-15.5 119.8-41.4l140.5 140.5c8.2 8.2 20.4 8.2 28.6 0 8.2-8.2 8.2-20.4 0-28.6zM41 191.4c0-82.8 68.2-150.1 151.9-150.1s151.9 67.3 151.9 150.1-68.2 150.1-151.9 150.1S41 274.1 41 191.4z"
                    ></path>
                </svg>
            )
        case 'pencil':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M21.2799 6.40005L11.7399 15.94C10.7899 16.89 7.96987 17.33 7.33987 16.7C6.70987 16.07 7.13987 13.25 8.08987 12.3L17.6399 2.75002C17.8754 2.49308 18.1605 2.28654 18.4781 2.14284C18.7956 1.99914 19.139 1.92124 19.4875 1.9139C19.8359 1.90657 20.1823 1.96991 20.5056 2.10012C20.8289 2.23033 21.1225 2.42473 21.3686 2.67153C21.6147 2.91833 21.8083 3.21243 21.9376 3.53609C22.0669 3.85976 22.1294 4.20626 22.1211 4.55471C22.1128 4.90316 22.0339 5.24635 21.8894 5.5635C21.7448 5.88065 21.5375 6.16524 21.2799 6.40005V6.40005Z"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M11 4H6C4.93913 4 3.92178 4.42142 3.17163 5.17157C2.42149 5.92172 2 6.93913 2 8V18C2 19.0609 2.42149 20.0783 3.17163 20.8284C3.92178 21.5786 4.93913 22 6 22H17C19.21 22 20 20.2 20 18V13"
                        stroke={color}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'trash':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    enableBackground="new 0 0 465.311 465.311"
                    version="1.1"
                    viewBox="0 0 465.311 465.311"
                    xmlSpace="preserve"
                    style={{ transform }}
                    width={width}
                    height={height}
                >
                    <path
                        fill={color}
                        d="M372.811 51.002h-59.908V36.566C312.902 16.404 296.499 0 276.335 0h-87.356c-20.163 0-36.567 16.404-36.567 36.566v14.436H92.5c-20.726 0-37.587 16.861-37.587 37.587v38.91c0 8.284 6.716 15 15 15h7.728v307.812c0 8.284 6.716 15 15 15H372.67c8.284 0 15-6.716 15-15V142.499h7.728c8.284 0 15-6.716 15-15v-38.91c-.001-20.726-16.862-37.587-37.587-37.587zM182.412 36.566A6.574 6.574 0 01188.979 30h87.356a6.574 6.574 0 016.567 6.566v14.436h-100.49V36.566zM84.914 88.589c0-4.184 3.403-7.587 7.587-7.587h280.31c4.184 0 7.587 3.403 7.587 7.587v23.91H84.914v-23.91zM357.67 435.311H107.641V142.499H357.67v292.812z"
                    ></path>
                    <path
                        fill={color}
                        d="M137.41 413.485c5.523 0 10-4.477 10-10V166.497c0-5.523-4.477-10-10-10s-10 4.477-10 10v236.988c0 5.523 4.477 10 10 10zM200.907 413.485c5.523 0 10-4.477 10-10V166.497c0-5.523-4.477-10-10-10s-10 4.477-10 10v236.988c0 5.523 4.477 10 10 10zM264.404 413.485c5.523 0 10-4.477 10-10V166.497c0-5.523-4.477-10-10-10s-10 4.477-10 10v236.988c0 5.523 4.477 10 10 10zM327.901 413.485c5.523 0 10-4.477 10-10V166.497c0-5.523-4.477-10-10-10s-10 4.477-10 10v236.988c0 5.523 4.477 10 10 10z"
                    ></path>
                </svg>
            )
        case 'plus':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    enableBackground="new 0 0 42 42"
                    version="1.1"
                    viewBox="0 0 42 42"
                    xmlSpace="preserve"
                    style={{ transform }}
                >
                    <path
                        fill={color}
                        d="M42 19L23 19 23 0 19 0 19 19 0 19 0 23 19 23 19 42 23 42 23 23 42 23z"
                    ></path>
                </svg>
            )
        case 'upload':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    enableBackground="new 0 0 486.3 486.3"
                    version="1.1"
                    viewBox="0 0 486.3 486.3"
                    xmlSpace="preserve"
                    style={{ transform }}
                >
                    <path
                        fill={color}
                        d="M395.5 135.8c-5.2-30.9-20.5-59.1-43.9-80.5-26-23.8-59.8-36.9-95-36.9-27.2 0-53.7 7.8-76.4 22.5-18.9 12.2-34.6 28.7-45.7 48.1-4.8-.9-9.8-1.4-14.8-1.4-42.5 0-77.1 34.6-77.1 77.1 0 5.5.6 10.8 1.6 16C16.7 200.7 0 232.9 0 267.2c0 27.7 10.3 54.6 29.1 75.9 19.3 21.8 44.8 34.7 72 36.2h86.8c7.5 0 13.5-6 13.5-13.5s-6-13.5-13.5-13.5h-85.6C61.4 349.8 27 310.9 27 267.1c0-28.3 15.2-54.7 39.7-69 5.7-3.3 8.1-10.2 5.9-16.4-2-5.4-3-11.1-3-17.2 0-27.6 22.5-50.1 50.1-50.1 5.9 0 11.7 1 17.1 3 6.6 2.4 13.9-.6 16.9-6.9 18.7-39.7 59.1-65.3 103-65.3 59 0 107.7 44.2 113.3 102.8.6 6.1 5.2 11 11.2 12 44.5 7.6 78.1 48.7 78.1 95.6 0 49.7-39.1 92.9-87.3 96.6h-73.7c-7.5 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5h75.2c30.5-2.2 59-16.2 80.2-39.6 21.1-23.2 32.6-53 32.6-84-.1-56.1-38.4-106-90.8-119.8z"
                    ></path>
                    <path
                        fill={color}
                        d="M324.2 280c5.3-5.3 5.3-13.8 0-19.1l-71.5-71.5c-2.5-2.5-6-4-9.5-4s-7 1.4-9.5 4l-71.5 71.5c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4l48.5-48.5v222.9c0 7.5 6 13.5 13.5 13.5s13.5-6 13.5-13.5V231.5l48.5 48.5c5.2 5.3 13.7 5.3 19 0z"
                    ></path>
                </svg>
            )
        case 'shapes':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    style={{ transform }}
                >
                    <g
                        fill={color}
                        fillRule="evenodd"
                        stroke="none"
                        strokeWidth="1"
                    >
                        <g fill={color} fillRule="nonzero">
                            <path d="M18.75 9a3.25 3.25 0 013.245 3.066l.005.184v6.5a3.25 3.25 0 01-3.066 3.245L18.75 22h-6.5a3.25 3.25 0 01-3.245-3.066L9 18.75v-6.5a3.25 3.25 0 013.066-3.245L12.25 9h6.5zm0 1.5h-6.5a1.75 1.75 0 00-1.744 1.606l-.006.144v6.5a1.75 1.75 0 001.606 1.744l.144.006h6.5a1.75 1.75 0 001.744-1.606l.006-.144v-6.5a1.75 1.75 0 00-1.606-1.744l-.144-.006zM8.75 2a6.751 6.751 0 016.709 6h-1.512A5.251 5.251 0 108 13.947v1.512A6.751 6.751 0 018.75 2z"></path>
                        </g>
                    </g>
                </svg>
            )
        case 'x':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={width || 18}
                    height={height || 18}
                    viewBox="0 0 24 24"
                >
                    <path
                        fill={color}
                        fillRule="evenodd"
                        d="M5.72 5.72a.75.75 0 011.06 0L12 10.94l5.22-5.22a.75.75 0 111.06 1.06L13.06 12l5.22 5.22a.75.75 0 11-1.06 1.06L12 13.06l-5.22 5.22a.75.75 0 01-1.06-1.06L10.94 12 5.72 6.78a.75.75 0 010-1.06z"
                    ></path>
                </svg>
            )
        case 'menu':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={'15'}
                    height={'15'}
                    fill="none"
                    viewBox="0 0 15 15"
                >
                    <path
                        fill={color}
                        fillRule="evenodd"
                        d="M1.5 3a.5.5 0 000 1h12a.5.5 0 000-1h-12zM1 7.5a.5.5 0 01.5-.5h12a.5.5 0 010 1h-12a.5.5 0 01-.5-.5zm0 4a.5.5 0 01.5-.5h12a.5.5 0 010 1h-12a.5.5 0 01-.5-.5z"
                        clipRule="evenodd"
                    ></path>
                </svg>
            )
        case '3-dot-menu':
            return (
                <svg
                    style={{ transform }}
                    fill={color || '#000000'}
                    width={width || '22px'}
                    height={height || '22px'}
                    viewBox="0 0 32 32"
                    enableBackground="new 0 0 32 32"
                    id="Glyph"
                    version="1.1"
                    xmlSpace="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                    <path
                        d="M13,16c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,14.346,13,16z"
                        id="XMLID_294_"
                    />
                    <path
                        d="M13,26c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,24.346,13,26z"
                        id="XMLID_295_"
                    />
                    <path
                        d="M13,6c0,1.654,1.346,3,3,3s3-1.346,3-3s-1.346-3-3-3S13,4.346,13,6z"
                        id="XMLID_297_"
                    />
                </svg>
            )
        case 'eye':
            return (
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    x="0"
                    y="0"
                    enableBackground="new 0 0 488.85 488.85"
                    version="1.1"
                    viewBox="0 0 488.85 488.85"
                    xmlSpace="preserve"
                >
                    <path d="M244.425 98.725c-93.4 0-178.1 51.1-240.6 134.1-5.1 6.8-5.1 16.3 0 23.1 62.5 83.1 147.2 134.2 240.6 134.2s178.1-51.1 240.6-134.1c5.1-6.8 5.1-16.3 0-23.1-62.5-83.1-147.2-134.2-240.6-134.2zm6.7 248.3c-62 3.9-113.2-47.2-109.3-109.3 3.2-51.2 44.7-92.7 95.9-95.9 62-3.9 113.2 47.2 109.3 109.3-3.3 51.1-44.8 92.6-95.9 95.9zm-3.1-47.4c-33.4 2.1-61-25.4-58.8-58.8 1.7-27.6 24.1-49.9 51.7-51.7 33.4-2.1 61 25.4 58.8 58.8-1.8 27.7-24.2 50-51.7 51.7z"></path>
                </svg>
            )
        case 'info':
            return (
                <svg
                    fill={color}
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    width={`${width}px`}
                    height={`${height}px`}
                    viewBox="0 0 512 512"
                    enableBackground="new 0 0 512 512"
                    xmlSpace="preserve"
                >
                    <g>
                        <path
                            d="M285.172,331.453c-12.453,13.25-20.547,18.781-26.094,18.781c-3.859,0-5.172-3.422-4.312-11.141
              c2.594-20.062,17.531-84.578,21.781-107.625c4.266-19.719,3-29.953-2.562-29.953c-10.641,0-36.734,17.516-53.828,35.016
              c-0.875,1.344-2.562,8.578-1.688,11.125c0,0.875,1.266,1.312,1.266,1.312c10.266-8.125,18.391-12.844,23.109-12.844
              c2.109,0,2.938,3.406,1.688,9.406c-5.125,25.625-13.672,65.406-20.078,98.281c-5.984,28.672-2.172,40.188,6.812,40.188
              s33.766-11.984,53.906-38.906c0.812-2.094,1.641-10.188,1.25-12.359C286.422,331.906,285.172,331.453,285.172,331.453z"
                        />
                        <path
                            d="M281.281,128c-7.297,0-16.25,3.414-20.516,7.703c-1.688,2.141-3.406,8.539-3.859,11.945
              c0.453,7.711,2.578,11.984,6.859,14.562c2.109,1.68,16.219,0.414,19.219-1.312c5.188-3.398,9.828-10.25,10.703-18.375
              c0.375-3.82-0.438-8.984-2.141-11.531C290.688,129.719,287.25,128,281.281,128z"
                        />
                        <path
                            d="M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472
              c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"
                        />
                    </g>
                </svg>
            )
        case 'analytics':
            return (
                <svg
                    fill={color || '#000'}
                    width={width || '16px'}
                    height={height || '15px'}
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M5,12a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V13A1,1,0,0,0,5,12ZM10,2A1,1,0,0,0,9,3V21a1,1,0,0,0,2,0V3A1,1,0,0,0,10,2ZM20,16a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V17A1,1,0,0,0,20,16ZM15,8a1,1,0,0,0-1,1V21a1,1,0,0,0,2,0V9A1,1,0,0,0,15,8Z" />
                </svg>
            )
        case 'open':
            return (
                <svg
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 17 17"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                    <path
                        d="M15 2v7.5h-1v-5.668l-9.334 9.334-0.707-0.707 9.459-9.459h-5.918v-1h7.5zM11 16h-10v-10h6.574v-1h-7.574v12h12v-7.714h-1v6.714z"
                        fill={color || '#000'}
                    />
                </svg>
            )
        case 'image':
            return (
                <svg
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <rect
                        width={`${width}px`}
                        height={`${height}px`}
                        fill={color || '#000'}
                    />
                    <path
                        d="M21 16V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V18M21 16V4C21 3.44772 20.5523 3 20 3H4C3.44772 3 3 3.44772 3 4V18M21 16L15.4829 12.3219C15.1843 12.1228 14.8019 12.099 14.4809 12.2595L3 18"
                        stroke={color || '#000'}
                        strokeLinejoin="round"
                    />
                    <circle
                        cx="8"
                        cy="9"
                        r="2"
                        stroke={color || '#000'}
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'header':
            return (
                <svg
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7 5C7.55228 5 8 5.44772 8 6V11.5H16V6C16 5.44772 16.4477 5 17 5C17.5523 5 18 5.44772 18 6V12.5V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V13.5H8V19C8 19.5523 7.55228 20 7 20C6.44772 20 6 19.5523 6 19V12.5V6C6 5.44772 6.44772 5 7 5Z"
                        fill={color || '#000'}
                    />
                </svg>
            )
        case 'video-carousel':
            return (
                <svg
                    fill={color || '#000'}
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 32 32"
                    id="icon"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M22,26H10a2,2,0,0,1-2-2V8a2,2,0,0,1,2-2H22a2,2,0,0,1,2,2V24A2,2,0,0,1,22,26ZM10,8V24H22V8Z" />
                    <path d="M4,24H0V22H4V10H0V8H4a2,2,0,0,1,2,2V22A2,2,0,0,1,4,24Z" />
                    <path d="M32,24H28a2,2,0,0,1-2-2V10a2,2,0,0,1,2-2h4v2H28V22h4Z" />
                    <rect
                        id="_Transparent_Rectangle_"
                        data-name="&lt;Transparent Rectangle&gt;"
                        fill="none"
                        width="32"
                        height="32"
                    />
                </svg>
            )
        case 'product':
            return (
                <svg
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M15.5777 3.38197L17.5777 4.43152C19.7294 5.56066 20.8052 6.12523 21.4026 7.13974C22 8.15425 22 9.41667 22 11.9415V12.0585C22 14.5833 22 15.8458 21.4026 16.8603C20.8052 17.8748 19.7294 18.4393 17.5777 19.5685L15.5777 20.618C13.8221 21.5393 12.9443 22 12 22C11.0557 22 10.1779 21.5393 8.42229 20.618L6.42229 19.5685C4.27063 18.4393 3.19479 17.8748 2.5974 16.8603C2 15.8458 2 14.5833 2 12.0585V11.9415C2 9.41667 2 8.15425 2.5974 7.13974C3.19479 6.12523 4.27063 5.56066 6.42229 4.43152L8.42229 3.38197C10.1779 2.46066 11.0557 2 12 2C12.9443 2 13.8221 2.46066 15.5777 3.38197Z"
                        stroke={color || '#000'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M21 7.5L12 12M12 12L3 7.5M12 12V21.5"
                        stroke={color || '#000'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                </svg>
            )
        case 'upsell':
            return (
                <svg
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 1024 1024"
                    className="icon"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill={color || '#000'}
                        d="M704 288h131.072a32 32 0 0131.808 28.8L886.4 512h-64.384l-16-160H704v96a32 32 0 11-64 0v-96H384v96a32 32 0 01-64 0v-96H217.92l-51.2 512H512v64H131.328a32 32 0 01-31.808-35.2l57.6-576a32 32 0 0131.808-28.8H320v-22.336C320 154.688 405.504 64 512 64s192 90.688 192 201.664v22.4zm-64 0v-22.336C640 189.248 582.272 128 512 128c-70.272 0-128 61.248-128 137.664v22.4h256zm201.408 483.84L768 698.496V928a32 32 0 11-64 0V698.496l-73.344 73.344a32 32 0 11-45.248-45.248l128-128a32 32 0 0145.248 0l128 128a32 32 0 11-45.248 45.248z"
                    />
                </svg>
            )
        case 'rename':
            return (
                <svg
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M11.75 2C11.3358 2 11 2.33579 11 2.75C11 3.16421 11.3358 3.5 11.75 3.5H13.25V24.5H11.75C11.3358 24.5 11 24.8358 11 25.25C11 25.6642 11.3358 26 11.75 26H16.25C16.6642 26 17 25.6642 17 25.25C17 24.8358 16.6642 24.5 16.25 24.5H14.75V3.5H16.25C16.6642 3.5 17 3.16421 17 2.75C17 2.33579 16.6642 2 16.25 2H11.75Z"
                        fill={color || '#000'}
                    />
                    <path
                        d="M6.25 6.01958H12.25V7.51958H6.25C5.2835 7.51958 4.5 8.30308 4.5 9.26958V18.7696C4.5 19.7361 5.2835 20.5196 6.25 20.5196H12.25V22.0196H6.25C4.45507 22.0196 3 20.5645 3 18.7696V9.26958C3 7.47465 4.45507 6.01958 6.25 6.01958Z"
                        fill="#212121"
                    />
                    <path
                        d="M21.75 20.5196H15.75V22.0196H21.75C23.5449 22.0196 25 20.5645 25 18.7696V9.26958C25 7.47465 23.5449 6.01958 21.75 6.01958H15.75V7.51958H21.75C22.7165 7.51958 23.5 8.30308 23.5 9.26958V18.7696C23.5 19.7361 22.7165 20.5196 21.75 20.5196Z"
                        fill="#212121"
                    />
                </svg>
            )
        case 'archive':
            return (
                <svg
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3.95526 2.25C3.97013 2.25001 3.98505 2.25001 4.00001 2.25001L20.0448 2.25C20.4776 2.24995 20.8744 2.24991 21.1972 2.29331C21.5527 2.3411 21.9284 2.45355 22.2374 2.76257C22.5465 3.07159 22.6589 3.44732 22.7067 3.8028C22.7501 4.12561 22.7501 4.52245 22.75 4.95526V5.04475C22.7501 5.47757 22.7501 5.8744 22.7067 6.19721C22.6589 6.55269 22.5465 6.92842 22.2374 7.23744C21.9437 7.53121 21.5896 7.64733 21.25 7.69914V13.0564C21.25 14.8942 21.25 16.3498 21.0969 17.489C20.9392 18.6615 20.6071 19.6104 19.8588 20.3588C19.1104 21.1071 18.1615 21.4392 16.989 21.5969C15.8498 21.75 14.3942 21.75 12.5564 21.75H11.4436C9.60583 21.75 8.1502 21.75 7.01098 21.5969C5.83856 21.4392 4.88961 21.1071 4.14125 20.3588C3.39289 19.6104 3.06077 18.6615 2.90314 17.489C2.74998 16.3498 2.74999 14.8942 2.75001 13.0564L2.75001 7.69914C2.41038 7.64733 2.05634 7.53121 1.76257 7.23744C1.45355 6.92842 1.3411 6.55269 1.29331 6.19721C1.24991 5.8744 1.24995 5.47757 1.25 5.04476C1.25001 5.02988 1.25001 5.01496 1.25001 5.00001C1.25001 4.98505 1.25001 4.97013 1.25 4.95526C1.24995 4.52244 1.24991 4.12561 1.29331 3.8028C1.3411 3.44732 1.45355 3.07159 1.76257 2.76257C2.07159 2.45355 2.44732 2.3411 2.8028 2.29331C3.12561 2.24991 3.52244 2.24995 3.95526 2.25ZM4.25001 7.75001V13C4.25001 14.9068 4.2516 16.2615 4.38977 17.2892C4.52503 18.2952 4.7787 18.8749 5.20191 19.2981C5.62512 19.7213 6.20477 19.975 7.21086 20.1102C8.23852 20.2484 9.59319 20.25 11.5 20.25H12.5C14.4068 20.25 15.7615 20.2484 16.7892 20.1102C17.7952 19.975 18.3749 19.7213 18.7981 19.2981C19.2213 18.8749 19.475 18.2952 19.6102 17.2892C19.7484 16.2615 19.75 14.9068 19.75 13V7.75001H12.75V14.0455L14.4425 12.1649C14.7196 11.8571 15.1938 11.8321 15.5017 12.1092C15.8096 12.3863 15.8346 12.8605 15.5575 13.1684L12.5575 16.5017C12.4152 16.6598 12.2126 16.75 12 16.75C11.7874 16.75 11.5848 16.6598 11.4425 16.5017L8.44254 13.1684C8.16544 12.8605 8.1904 12.3863 8.49828 12.1092C8.80617 11.8321 9.28038 11.8571 9.55748 12.1649L11.25 14.0455V7.75001H4.25001ZM20 6.25001C20.4926 6.25001 20.7866 6.24841 20.9973 6.22008C21.0939 6.2071 21.1423 6.19181 21.164 6.18285C21.1691 6.18077 21.1724 6.17916 21.1743 6.17815L21.1768 6.17678L21.1781 6.17434C21.1792 6.1724 21.1808 6.16909 21.1828 6.16404C21.1918 6.14226 21.2071 6.0939 21.2201 5.99734C21.2484 5.78662 21.25 5.49261 21.25 5.00001C21.25 4.5074 21.2484 4.21339 21.2201 4.00267C21.2071 3.90611 21.1918 3.85775 21.1828 3.83597C21.1808 3.83093 21.1792 3.82761 21.1781 3.82568L21.1768 3.82323L21.1743 3.82187C21.1724 3.82086 21.1691 3.81924 21.164 3.81717C21.1423 3.80821 21.0939 3.79291 20.9973 3.77993C20.7866 3.7516 20.4926 3.75001 20 3.75001H4.00001C3.5074 3.75001 3.21339 3.7516 3.00267 3.77993C2.90611 3.79291 2.85775 3.80821 2.83597 3.81717C2.83093 3.81924 2.82761 3.82086 2.82568 3.82187L2.82324 3.82324L2.82187 3.82568C2.82086 3.82761 2.81924 3.83093 2.81717 3.83597C2.80821 3.85775 2.79291 3.90611 2.77993 4.00267C2.7516 4.21339 2.75001 4.5074 2.75001 5.00001C2.75001 5.49261 2.7516 5.78662 2.77993 5.99734C2.79291 6.0939 2.80821 6.14226 2.81717 6.16404C2.81924 6.16909 2.82086 6.1724 2.82187 6.17434L2.82324 6.17677L2.82568 6.17815C2.82761 6.17916 2.83093 6.18077 2.83597 6.18285C2.85775 6.19181 2.90611 6.2071 3.00267 6.22008C3.21339 6.24841 3.5074 6.25001 4.00001 6.25001H20ZM2.82324 6.17677C2.82284 6.17636 2.82297 6.17644 2.82324 6.17677V6.17677Z"
                        fill="#000"
                    />
                </svg>
            )
        case 'unarchive':
            return (
                <svg
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 21 21"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        fill="none"
                        fillRule="evenodd"
                        stroke="#000000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        transform="translate(2 3)"
                    >
                        <path d="m1.5 4.5h14v8c0 1.1045695-.8954305 2-2 2h-10c-1.1045695 0-2-.8954305-2-2zm0-3.9777832h14c.5522847 0 1 .44771525 1 1v1.9777832c0 .55228475-.4477153 1-1 1h-14c-.55228475 0-1-.44771525-1-1v-1.9777832c0-.55228475.44771525-1 1-1z" />
                        <path d="m5.5 10.5 3-3 3 3" />
                    </g>
                </svg>
            )
        case 'video':
            return (
                <svg
                    fill={color || '#000'}
                    width="20px"
                    height="20px"
                    viewBox="0 -13.54 122.88 122.88"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlSpace="preserve"
                >
                    <g>
                        <path d="M12.14,0H32.8h29.43h28.8h19.71c3.34,0,6.38,1.37,8.58,3.56c2.2,2.2,3.56,5.24,3.56,8.58v7.13v57.25v7.09 c0,3.34-1.37,6.38-3.56,8.58c-2.2,2.2-5.24,3.56-8.58,3.56h-19.2c-0.16,0.03-0.33,0.04-0.51,0.04c-0.17,0-0.34-0.01-0.51-0.04 H62.74c-0.16,0.03-0.33,0.04-0.51,0.04c-0.17,0-0.34-0.01-0.51-0.04H33.31c-0.16,0.03-0.33,0.04-0.51,0.04 c-0.17,0-0.34-0.01-0.51-0.04H12.14c-3.34,0-6.38-1.37-8.58-3.56S0,86.95,0,83.61v-7.09V19.27v-7.13C0,8.8,1.37,5.76,3.56,3.56 C5.76,1.37,8.8,0,12.14,0L12.14,0z M55.19,31.24l20.53,14.32c0.32,0.2,0.61,0.48,0.84,0.81c0.92,1.33,0.58,3.14-0.74,4.06 L55.37,64.57c-0.5,0.41-1.15,0.66-1.85,0.66c-1.62,0-2.93-1.31-2.93-2.93V33.63h0.01c0-0.58,0.17-1.16,0.52-1.67 C52.05,30.64,53.87,30.32,55.19,31.24L55.19,31.24z M93.95,79.45V89.9h16.78c1.73,0,3.3-0.71,4.44-1.85 c1.14-1.14,1.85-2.71,1.85-4.44v-4.16H93.95L93.95,79.45z M88.1,89.9V79.45H65.16V89.9H88.1L88.1,89.9z M59.31,89.9V79.45H35.73 V89.9H59.31L59.31,89.9z M29.87,89.9V79.45H5.85v4.16c0,1.73,0.71,3.3,1.85,4.44c1.14,1.14,2.71,1.85,4.44,1.85H29.87L29.87,89.9z M5.85,73.6H32.8h29.43h28.8h26V22.2h-26h-28.8H32.8H5.85V73.6L5.85,73.6z M88.1,16.35V5.85H65.16v10.49H88.1L88.1,16.35z M93.95,5.85v10.49h23.07v-4.2c0-1.73-0.71-3.3-1.85-4.44c-1.14-1.14-2.71-1.85-4.44-1.85H93.95L93.95,5.85z M59.31,16.35V5.85 H35.73v10.49H59.31L59.31,16.35z M29.87,16.35V5.85H12.14c-1.73,0-3.3,0.71-4.44,1.85c-1.14,1.14-1.85,2.71-1.85,4.44v4.2H29.87 L29.87,16.35z" />
                    </g>
                </svg>
            )
        case 'pages':
            return (
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M22 9H2M2 7.8L2 16.2C2 17.8802 2 18.7202 2.32698 19.362C2.6146 19.9265 3.07354 20.3854 3.63803 20.673C4.27976 21 5.11984 21 6.8 21H17.2C18.8802 21 19.7202 21 20.362 20.673C20.9265 20.3854 21.3854 19.9265 21.673 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27977 21.673 4.63803C21.3854 4.07354 20.9265 3.6146 20.362 3.32698C19.7202 3 18.8802 3 17.2 3L6.8 3C5.11984 3 4.27976 3 3.63803 3.32698C3.07354 3.6146 2.6146 4.07354 2.32698 4.63803C2 5.27976 2 6.11984 2 7.8Z"
                        stroke={color || '#000'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'embed':
            return (
                <svg
                    height="20px"
                    width="20px"
                    version="1.1"
                    id="_x32_"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                    xmlSpace="preserve"
                >
                    <g>
                        <path
                            fill={color || '#000'}
                            d="M153.527,138.934c-0.29,0-0.581,0.088-0.826,0.258L0.641,242.995C0.238,243.27,0,243.721,0,244.213v27.921
            c0,0.484,0.238,0.943,0.641,1.21l152.06,103.811c0.246,0.17,0.536,0.258,0.826,0.258c0.238,0,0.468-0.064,0.686-0.169
            c0.484-0.258,0.782-0.758,0.782-1.306v-44.478c0-0.476-0.238-0.936-0.641-1.202L48.769,258.166l105.585-72.068
            c0.403-0.282,0.641-0.734,0.641-1.226V140.41c0-0.548-0.298-1.049-0.782-1.299C153.995,138.991,153.765,138.934,153.527,138.934z"
                        />
                        <path
                            fill={color || '#000'}
                            d="M511.358,242.995l-152.06-103.803c-0.246-0.169-0.536-0.258-0.827-0.258c-0.238,0-0.467,0.056-0.685,0.177
            c-0.484,0.25-0.782,0.751-0.782,1.299v44.478c0,0.484,0.238,0.936,0.641,1.21l105.586,72.068l-105.586,72.092
            c-0.403,0.266-0.641,0.725-0.641,1.217v44.462c0,0.548,0.298,1.049,0.782,1.306c0.218,0.105,0.448,0.169,0.685,0.169
            c0.291,0,0.581-0.088,0.827-0.258l152.06-103.811c0.404-0.267,0.642-0.726,0.642-1.21v-27.921
            C512,243.721,511.762,243.27,511.358,242.995z"
                        />
                        <path
                            fill={color || '#000'}
                            d="M325.507,114.594h-42.502c-0.629,0-1.186,0.395-1.387,0.984l-96.517,279.885
            c-0.153,0.443-0.08,0.943,0.194,1.322c0.278,0.387,0.722,0.621,1.198,0.621h42.506c0.625,0,1.182-0.395,1.387-0.992l96.513-279.868
            c0.153-0.452,0.081-0.952-0.193-1.339C326.427,114.828,325.982,114.594,325.507,114.594z"
                        />
                    </g>
                </svg>
            )
        case 'graph':
            return (
                <svg
                    fill={color || '#000'}
                    width="20px"
                    height="20px"
                    viewBox="0 0 36 36"
                    version="1.1"
                    preserveAspectRatio="xMidYMid meet"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M 32 5 L 4 5 C 2.895 5 2 5.895 2 7 L 2 29 C 2 30.105 2.895 31 4 31 L 32 31 C 33.105 31 34 30.105 34 29 L 34 7 C 34 5.895 33.105 5 32 5 Z M 4 29 L 4 7 L 32 7 L 32 29 Z"></path>
                    <polygon points="15.62 15.222 9.602 23.968 5.55 20.384 6.61 19.186 9.308 21.572 15.634 12.38 22.384 22.395 29.138 13.47 30.414 14.436 22.308 25.145"></polygon>
                    <rect x="0" y="0" width="36" height="36" fillOpacity="0" />
                </svg>
            )
        case 'bar-chart':
            return (
                <svg
                    fill={color || '#000'}
                    width="20px"
                    height="20px"
                    viewBox="-0.5 0 32 32"
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="xMidYMid"
                >
                    <path d="M30.000,32.000 L23.000,32.000 C22.447,32.000 22.000,31.552 22.000,31.000 L22.000,1.000 C22.000,0.448 22.447,-0.000 23.000,-0.000 L30.000,-0.000 C30.553,-0.000 31.000,0.448 31.000,1.000 L31.000,31.000 C31.000,31.552 30.553,32.000 30.000,32.000 ZM29.000,2.000 L24.000,2.000 L24.000,30.000 L29.000,30.000 L29.000,2.000 ZM19.000,32.000 L12.000,32.000 C11.448,32.000 11.000,31.552 11.000,31.000 L11.000,17.000 C11.000,16.448 11.448,16.000 12.000,16.000 L19.000,16.000 C19.553,16.000 20.000,16.448 20.000,17.000 L20.000,31.000 C20.000,31.552 19.553,32.000 19.000,32.000 ZM18.000,18.000 L13.000,18.000 L13.000,30.000 L18.000,30.000 L18.000,18.000 ZM8.000,32.000 L1.000,32.000 C0.448,32.000 0.000,31.552 0.000,31.000 L0.000,11.000 C0.000,10.448 0.448,10.000 1.000,10.000 L8.000,10.000 C8.552,10.000 9.000,10.448 9.000,11.000 L9.000,31.000 C9.000,31.552 8.552,32.000 8.000,32.000 ZM7.000,12.000 L2.000,12.000 L2.000,30.000 L7.000,30.000 L7.000,12.000 Z" />
                </svg>
            )
        case 'team':
            return (
                <svg
                    fill={color || '#000'}
                    width="20px"
                    height="20px"
                    viewBox="0 0 1024 1024"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z" />
                </svg>
            )
        case 'gear':
            return (
                <svg
                    width="20px"
                    height="20px"
                    viewBox="0 0 32 32"
                    enableBackground="new 0 0 32 32"
                    id="Editable-line"
                    version="1.1"
                    xmlSpace="preserve"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                >
                    <circle
                        cx="16"
                        cy="16"
                        fill="none"
                        id="XMLID_224_"
                        r="4"
                        stroke={color || '#000'}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                    <path
                        d="  M27.758,10.366l-1-1.732c-0.552-0.957-1.775-1.284-2.732-0.732L23.5,8.206C21.5,9.36,19,7.917,19,5.608V5c0-1.105-0.895-2-2-2h-2  c-1.105,0-2,0.895-2,2v0.608c0,2.309-2.5,3.753-4.5,2.598L7.974,7.902C7.017,7.35,5.794,7.677,5.242,8.634l-1,1.732  c-0.552,0.957-0.225,2.18,0.732,2.732L5.5,13.402c2,1.155,2,4.041,0,5.196l-0.526,0.304c-0.957,0.552-1.284,1.775-0.732,2.732  l1,1.732c0.552,0.957,1.775,1.284,2.732,0.732L8.5,23.794c2-1.155,4.5,0.289,4.5,2.598V27c0,1.105,0.895,2,2,2h2  c1.105,0,2-0.895,2-2v-0.608c0-2.309,2.5-3.753,4.5-2.598l0.526,0.304c0.957,0.552,2.18,0.225,2.732-0.732l1-1.732  c0.552-0.957,0.225-2.18-0.732-2.732L26.5,18.598c-2-1.155-2-4.041,0-5.196l0.526-0.304C27.983,12.546,28.311,11.323,27.758,10.366z  "
                        fill="none"
                        id="XMLID_242_"
                        stroke={color || '#000'}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit="10"
                        strokeWidth="2"
                    />
                </svg>
            )
        case 'paintbrush':
            return (
                <svg
                    fill={color || '#000'}
                    width="20px"
                    height="20px"
                    viewBox="0 0 1920 1920"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M517.257 1127.343c72.733 0 148.871 36.586 221.274 107.45 87.455 110.418 114.922 204.135 81.632 278.296-72.733 162.274-412.664 234.897-618.666 259.178 34.609-82.62 75.15-216.88 75.15-394.645 0-97.123 66.47-195.455 157.88-233.689 26.698-11.097 54.494-16.59 82.73-16.59Zm229.404-167.109c54.055 28.895 106.462 65.371 155.133 113.494l13.844 15.6c28.016 35.378 50.649 69.987 70.425 104.155-29.554 26.259-59.878 52.737-90.75 79.545-18.898-35.488-43.069-71.964-72.843-109.319l-4.285-4.834c-48.342-47.683-99.43-83.39-151.727-107.011 26.368-30.653 53.066-61.196 80.203-91.63Zm1046.49-803.133c7.801 7.8 18.129 21.754 16.92 52.187-6.043 155.683-284.338 494.405-740.509 909.266-19.995-32.302-41.969-64.822-67.788-97.453l-22.523-25.27c-49.22-48.671-101.408-88.883-156.012-121.074 350.588-385.855 728.203-734.356 910.254-741.828 30.983-.109 44.497 9.01 59.658 24.172Zm126.678 56.472c2.087-53.615-14.832-99.98-56.142-141.29-34.28-34.279-81.962-51.198-134.588-49.11-304.554 12.414-912.232 683.377-1179.54 996.17-53.616-5.383-106.682 2.088-157.441 23.402-132.61 55.263-225.339 193.038-225.339 334.877 0 268.517-103.935 425.737-104.923 427.275L0 1896.747l110.307-6.153c69.217-3.735 681.29-45.375 810.165-332.46 24.39-54.604 29.225-113.163 15.93-175.239 374.32-321.802 972.11-879.71 983.427-1169.322"
                        fillRule="evenodd"
                    />
                </svg>
            )
        case 'collection':
            return (
                <svg
                    height="20px"
                    width="20px"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 52.526 52.526"
                    xmlSpace="preserve"
                >
                    <g>
                        <path
                            fill="#010002"
                            d="M38.684,12.468c-5.041,0-9.447,2.717-11.867,6.753c-2.908-4.162-8.129-6.847-12.975-6.847
		C6.209,12.374,0,18.583,0,26.216c0,7.633,6.209,13.842,13.842,13.842c4.813,0,9.992-2.648,12.912-6.762
		c2.406,4.094,6.846,6.856,11.93,6.856c7.633,0,13.842-6.21,13.842-13.843S46.317,12.468,38.684,12.468z M13.842,35.792
		c-5.279,0-9.576-4.296-9.576-9.575c0-5.281,4.297-9.576,9.576-9.576c5.086,0,10.998,4.183,10.998,9.576
		C24.84,31.609,18.928,35.792,13.842,35.792z M38.684,35.887c-5.281,0-9.576-4.296-9.576-9.576s4.295-9.576,9.576-9.576
		c5.279,0,9.576,4.296,9.576,9.576S43.963,35.887,38.684,35.887z"
                        />
                    </g>
                </svg>
            )
        case 'code':
            return (
                <svg
                    width={`${width || 20}px`}
                    height={`${height || 20}px`}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9 6L3 12L9 18M15 6L21 12L15 18"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'undo':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill={color}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.53033 3.46967C7.82322 3.76256 7.82322 4.23744 7.53033 4.53033L5.81066 6.25L15.0358 6.25C15.94 6.24999 16.6693 6.24998 17.2576 6.3033C17.864 6.35826 18.3938 6.47456 18.875 6.75241C19.4451 7.08154 19.9185 7.55492 20.2476 8.12499C20.5254 8.60624 20.6417 9.13604 20.6967 9.74239C20.75 10.3307 20.75 11.06 20.75 11.9643V12.0358C20.75 12.94 20.75 13.6693 20.6967 14.2576C20.6418 14.8639 20.5255 15.3937 20.2476 15.875C19.9185 16.4451 19.4451 16.9185 18.875 17.2476C18.3938 17.5254 17.864 17.6417 17.2576 17.6967C16.6693 17.75 15.94 17.75 15.0358 17.75H8.00001C7.58579 17.75 7.25001 17.4142 7.25001 17C7.25001 16.5858 7.58579 16.25 8.00001 16.25H15C15.9484 16.25 16.6096 16.2493 17.1222 16.2028C17.6245 16.1573 17.9101 16.0726 18.125 15.9486C18.4671 15.7511 18.7511 15.467 18.9486 15.125C19.0726 14.9101 19.1573 14.6245 19.2028 14.1222C19.2493 13.6096 19.25 12.9484 19.25 12C19.25 11.0516 19.2493 10.3904 19.2028 9.87779C19.1573 9.37548 19.0726 9.0899 18.9486 8.87499C18.7511 8.53295 18.467 8.24892 18.125 8.05144C17.9101 7.92737 17.6245 7.84271 17.1222 7.79718C16.6096 7.75072 15.9484 7.75 15 7.75H5.81066L7.53033 9.46967C7.82322 9.76256 7.82322 10.2374 7.53033 10.5303C7.23744 10.8232 6.76256 10.8232 6.46967 10.5303L3.46967 7.53033C3.17678 7.23744 3.17678 6.76256 3.46967 6.46967L6.46967 3.46967C6.76256 3.17678 7.23744 3.17678 7.53033 3.46967Z"
                    />
                </svg>
            )

        case 'redo':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill={color}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16.4697 3.46967C16.7626 3.17678 17.2374 3.17678 17.5303 3.46967L20.5303 6.46967C20.8232 6.76256 20.8232 7.23744 20.5303 7.53033L17.5303 10.5303C17.2374 10.8232 16.7626 10.8232 16.4697 10.5303C16.1768 10.2374 16.1768 9.76256 16.4697 9.46967L18.1893 7.75H9.00001C8.05159 7.75 7.39042 7.75072 6.8778 7.79718C6.37549 7.84271 6.0899 7.92737 5.875 8.05144C5.53296 8.24892 5.24893 8.53295 5.05145 8.87499C4.92738 9.0899 4.84271 9.37548 4.79718 9.87779C4.75072 10.3904 4.75 11.0516 4.75 12C4.75 12.9484 4.75072 13.6096 4.79718 14.1222C4.84271 14.6245 4.92737 14.9101 5.05144 15.125C5.24892 15.467 5.53296 15.7511 5.875 15.9486C6.0899 16.0726 6.37549 16.1573 6.87779 16.2028C7.39041 16.2493 8.05158 16.25 9 16.25H16C16.4142 16.25 16.75 16.5858 16.75 17C16.75 17.4142 16.4142 17.75 16 17.75H8.96423C8.05998 17.75 7.3307 17.75 6.7424 17.6967C6.13605 17.6417 5.60625 17.5254 5.125 17.2476C4.55493 16.9185 4.08154 16.4451 3.75241 15.875C3.47455 15.3937 3.35826 14.8639 3.3033 14.2576C3.24998 13.6693 3.24999 12.94 3.25 12.0358V11.9642C3.24999 11.06 3.24999 10.3307 3.30331 9.74239C3.35826 9.13604 3.47456 8.60624 3.75241 8.12499C4.08154 7.55492 4.55493 7.08154 5.125 6.75241C5.60625 6.47456 6.13605 6.35826 6.7424 6.3033C7.33069 6.24998 8.05997 6.24999 8.96421 6.25L18.1893 6.25L16.4697 4.53033C16.1768 4.23744 16.1768 3.76256 16.4697 3.46967Z"
                    />
                </svg>
            )
        case 'chevron-down':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18 9L12 15L6 9"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'chevron-up':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M18 15L12 9L6 15"
                        stroke={color}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'header-one':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-System-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_text_header_1_20_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M16.5535,4.00284 C16.6124,4.00911 16.6682,4.02559 16.7192,4.0505 C16.7855,4.08275 16.8426,4.12877 16.8876,4.18416 C16.9609,4.27418 17.0024,4.38892 17,4.5094 L17,15.5 C17,15.7762 16.7761,16 16.5,16 C16.2239,16 16,15.7762 16,15.5 L16,6.73173 C15.4171,7.56559 14.6397,8.34115 13.7773,8.91604 C13.5476,9.06922 13.2371,9.00713 13.084,8.77736 C12.9308,8.5476 12.9929,8.23716 13.2226,8.08399 C14.5593667,7.19284056 15.6167667,5.78472898 15.9571622,4.60700075 L16.0097,4.40171 C16.0177,4.36158 16.0305,4.32319 16.0474,4.28716 C16.0807,4.21631 16.1296,4.15567 16.1888,4.10862 C16.2447,4.06415 16.3103,4.03138 16.3819,4.01404 C16.4369,4.00064 16.4948,3.99645 16.5535,4.00284 Z M9.5,4.00001 C9.77614,4.00001 10,4.22387 10,4.50001 L10,15.50001 C10,15.7762 9.77614,16.00001 9.5,16.00001 C9.22386,16.00001 9,15.7762 9,15.50001 L9,10.00001 L3,10.00001 L3,15.50001 C3,15.7762 2.77614,16.00001 2.5,16.00001 C2.22386,16.00001 2,15.7762 2,15.50001 L2,4.50001 C2,4.22387 2.22386,4.00001 2.5,4.00001 C2.77614,4.00001 3,4.22387 3,4.50001 L3,9.00001 L9,9.00001 L9,4.50001 C9,4.22387 9.22386,4.00001 9.5,4.00001 Z"
                                id="🎨-Color"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'header-two':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-System-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_text_header_2_20_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M9.5,4 C9.77614,4 10,4.22386 10,4.5 L10,15.5 C10,15.7761 9.77614,16 9.5,16 C9.22386,16 9,15.7761 9,15.5 L9,10 L3,10 L3,15.5 C3,15.7761 2.77614,16 2.5,16 C2.22386,16 2,15.7761 2,15.5 L2,4.5 C2,4.22386 2.22386,4 2.5,4 C2.77614,4 3,4.22386 3,4.5 L3,9 L9,9 L9,4.5 C9,4.22386 9.22386,4 9.5,4 Z M14.5,4 C15.7357,4 16.9028,4.56595 17.5472,5.53582 C18.2085,6.53127 18.2635,7.86601 17.4287,9.25725 C17.0078,9.95888 16.4214,10.5037 15.8137,10.9737 C15.6107667,11.1305667 15.4025889,11.2812556 15.1950926,11.4274556 L14.753,11.7349 C14.4886,11.9175 14.2322,12.0947 13.9841,12.2775 C12.9663,13.0275 12.198,13.7941 12.033,15 L17.5,15 C17.7761,15 18,15.2239 18,15.5 C18,15.7761 17.7761,16 17.5,16 L11.5,16 C11.2239,16 11,15.7761 11,15.5 C11,13.5038 12.1677,12.3738 13.3909,11.4725 L13.7878375,11.187725 L13.7878375,11.187725 L14.316,10.8213 C14.6233,10.6087 14.9204,10.4004 15.2019,10.1826 C15.7661,9.74632 16.2422,9.29112 16.5713,8.74275 C17.2365,7.63399 17.1324,6.71873 16.7142,6.08918 C16.279,5.43405 15.4461,5 14.5,5 C13.0567,5 12,6.24935 12,7.5 C12,7.77614 11.7761,8 11.5,8 C11.2239,8 11,7.77614 11,7.5 C11,5.75065 12.4523,4 14.5,4 Z"
                                id="🎨-Color"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'header-three':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 20 20"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-System-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_text_header_3_20_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M9.5,4 C9.74545778,4 9.9496079,4.17687704 9.99194425,4.41012499 L10,4.5 L10,15.5 C10,15.7761 9.77614,16 9.5,16 C9.25454222,16 9.0503921,15.8230914 9.00805575,15.5898645 L9,15.5 L9,10 L3,10 L3,15.5 C3,15.7761 2.77614,16 2.5,16 C2.25454222,16 2.0503921,15.8230914 2.00805575,15.5898645 L2,15.5 L2,4.5 C2,4.22386 2.22386,4 2.5,4 C2.74545778,4 2.9496079,4.17687704 2.99194425,4.41012499 L3,4.5 L3,9 L9,9 L9,4.5 C9,4.22386 9.22386,4 9.5,4 Z M14.5,4 C16.7641,4 18,5.612 18,7 C18,7.60438 17.8798,8.48731 17.2849,9.22608 C17.0528,9.51432 16.7595,9.76726 16.3954,9.97019 C16.8092,10.1675 17.2088,10.4533 17.5077,10.8676 C17.8194,11.2995 18,11.8413 18,12.5 C18,13.7452 17.5791,14.6475 16.8826,15.2279 C16.2022,15.7949 15.3243,16 14.5,16 C13.7006,16 12.9701,15.8678 12.36,15.4865 C11.7397,15.0988 11.3034,14.4914 11.0257,13.6581 C10.9383,13.3961 11.0799,13.113 11.3419,13.0257 C11.6039,12.9383 11.887,13.0799 11.9744,13.3419 C12.1966,14.0086 12.5103,14.4012 12.89,14.6385 C13.2799,14.8822 13.7995,15 14.5,15 C15.1757,15 15.7979,14.8301 16.2424,14.4596 C16.6709,14.1025 17,13.5048 17,12.5 C17,12.0337 16.8757,11.7005 16.6968,11.4528 C16.5143,11.1998 16.253,11.006 15.9377,10.86 C15.2945,10.5622 14.5069,10.5 14,10.5 C13.7239,10.5 13.5,10.2761 13.5,10 C13.5,9.72386 13.7239,9.5 14,9.5 C15.4178,9.5 16.1312,9.06444 16.506,8.59892 C16.8975,8.11269 17,7.49562 17,7 C17,6.188 16.2359,5 14.5,5 C13.5944,5 13.0162,5.2782 12.6443,5.60208 C12.2632,5.93391 12.066,6.34286 11.9803,6.63893 C11.9036,6.9042 11.6263,7.05704 11.3611,6.98031 C11.0958,6.90358 10.943,6.62634 11.0197,6.36107 C11.1462,5.92381 11.4308,5.33276 11.9876,4.84792 C12.5535,4.35513 13.3693,4 14.5,4 Z"
                                id="🎨-Color"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'paragraph':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-System-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_text_first_line_24_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M21.25,18 C21.6642,18 22,18.3358 22,18.75 C22,19.1296833 21.7178347,19.4434889 21.3517677,19.4931531 L21.25,19.5 L2.75,19.5 C2.33579,19.5 2,19.1642 2,18.75 C2,18.3703167 2.28215688,18.0565111 2.64823019,18.0068469 L2.75,18 L21.25,18 Z M21.25,11.5 C21.6642,11.5 22,11.8358 22,12.25 C22,12.6642 21.6642,13 21.25,13 L2.75,13 C2.33579,13 2,12.6642 2,12.25 C2,11.8358 2.33579,11.5 2.75,11.5 L21.25,11.5 Z M2.71967,3.21967 C2.98593364,2.95340636 3.40260223,2.92920058 3.69621222,3.14705264 L3.78033,3.21967 L5.78033,5.21967 C6.04659364,5.48593364 6.07079942,5.90260223 5.85294736,6.19621222 L5.78033,6.28033 L3.78033,8.28033 C3.48744,8.57322 3.01256,8.57322 2.71967,8.28033 C2.45340636,8.01406636 2.42920058,7.59739777 2.64705264,7.30378778 L2.71967,7.21967 L4.18934,5.75 L2.71967,4.28033 C2.42678,3.98744 2.42678,3.51256 2.71967,3.21967 Z M21.25,5 C21.6642,5 22,5.33579 22,5.75 C22,6.1296925 21.7178347,6.44349042 21.3517677,6.49315332 L21.25,6.5 L9.75,6.5 C9.33579,6.5 9,6.16421 9,5.75 C9,5.3703075 9.28215687,5.05650958 9.64823019,5.00684668 L9.75,5 L21.25,5 Z"
                                id="🎨-Color"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'list-bullet':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-Product-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_text_bullet_list_24_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M3.24928905,16 C3.93925235,16 4.49857811,16.5593258 4.49857811,17.2492891 C4.49857811,17.9392523 3.93925235,18.4985781 3.24928905,18.4985781 C2.55932576,18.4985781 2,17.9392523 2,17.2492891 C2,16.5593258 2.55932576,16 3.24928905,16 Z M6.75,16.5 L21.25,16.5 C21.6642136,16.5 22,16.8357864 22,17.25 C22,17.6296958 21.7178461,17.943491 21.3517706,17.9931534 L21.25,18 L6.75,18 C6.33578644,18 6,17.6642136 6,17.25 C6,16.8703042 6.28215388,16.556509 6.64822944,16.5068466 L6.75,16.5 L21.25,16.5 L6.75,16.5 Z M3.24928905,11 C3.93925235,11 4.49857811,11.5593258 4.49857811,12.2492891 C4.49857811,12.9392523 3.93925235,13.4985781 3.24928905,13.4985781 C2.55932576,13.4985781 2,12.9392523 2,12.2492891 C2,11.5593258 2.55932576,11 3.24928905,11 Z M6.75,11.5 L21.25,11.5 C21.6642136,11.5 22,11.8357864 22,12.25 C22,12.6296958 21.7178461,12.943491 21.3517706,12.9931534 L21.25,13 L6.75,13 C6.33578644,13 6,12.6642136 6,12.25 C6,11.8703042 6.28215388,11.556509 6.64822944,11.5068466 L6.75,11.5 L21.25,11.5 L6.75,11.5 Z M3.24928905,6 C3.93925235,6 4.49857811,6.55932576 4.49857811,7.24928905 C4.49857811,7.93925235 3.93925235,8.49857811 3.24928905,8.49857811 C2.55932576,8.49857811 2,7.93925235 2,7.24928905 C2,6.55932576 2.55932576,6 3.24928905,6 Z M6.75,6.5 L21.25,6.5 C21.6642136,6.5 22,6.83578644 22,7.25 C22,7.62969577 21.7178461,7.94349096 21.3517706,7.99315338 L21.25,8 L6.75,8 C6.33578644,8 6,7.66421356 6,7.25 C6,6.87030423 6.28215388,6.55650904 6.64822944,6.50684662 L6.75,6.5 L21.25,6.5 L6.75,6.5 Z"
                                id="🎨-Color"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'list-numbered':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-System-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_text_number_list_ltr_24_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M4.78759766,16.0166016 C5.28890225,16.0166016 5.67911644,16.1293934 5.95825195,16.3549805 C6.23738746,16.5805675 6.37695312,16.8733706 6.37695312,17.2333984 C6.37695312,17.8737011 6.05224934,18.2747388 5.40283203,18.4365234 L5.40283203,18.4536133 C5.74918793,18.4969078 6.0226227,18.6228017 6.22314453,18.8312988 C6.42366637,19.039796 6.52392578,19.2955714 6.52392578,19.5986328 C6.52392578,20.0566429 6.35644699,20.418944 6.02148438,20.6855469 C5.68652176,20.9521498 5.22396128,21.0854492 4.63378906,21.0854492 C4.12792716,21.0854492 3.7166357,21.0034188 3.39990234,20.8393555 L3.39990234,19.8994141 C3.72802898,20.1386731 4.11083766,20.2583008 4.54833984,20.2583008 C4.82405737,20.2583008 5.03881759,20.1990566 5.19262695,20.0805664 C5.34643632,19.9620762 5.42333984,19.7968761 5.42333984,19.5849609 C5.42333984,19.3662098 5.32820733,19.1975917 5.13793945,19.0791016 C4.94767157,18.9606114 4.68619958,18.9013672 4.35351562,18.9013672 L3.89892578,18.9013672 L3.89892578,18.0742188 L4.31933594,18.0742188 C4.95735996,18.0742188 5.27636719,17.8623068 5.27636719,17.4384766 C5.27636719,17.0397115 5.03141521,16.840332 4.54150391,16.840332 C4.21337727,16.840332 3.89437004,16.946288 3.58447266,17.1582031 L3.58447266,16.2763672 C3.9285499,16.1031892 4.32958755,16.0166016 4.78759766,16.0166016 Z M19.75,18 C20.1642136,18 20.5,18.3357864 20.5,18.75 C20.5,19.1642136 20.1642136,19.5 19.75,19.5 L10.75,19.5 C10.3357864,19.5 10,19.1642136 10,18.75 C10,18.3357864 10.3357864,18 10.75,18 L19.75,18 Z M4.96191406,9.51660156 C5.2102877,9.51660156 5.4330231,9.54907194 5.63012695,9.61401367 C5.8272308,9.6789554 5.99413994,9.77180929 6.13085938,9.89257812 C6.26757881,10.013347 6.37182581,10.1597485 6.44360352,10.3317871 C6.51538122,10.5038257 6.55126953,10.6957997 6.55126953,10.9077148 C6.55126953,11.1333019 6.51652053,11.3338207 6.44702148,11.5092773 C6.37752244,11.684734 6.28523821,11.8442376 6.17016602,11.987793 C6.05509383,12.1313484 5.92236403,12.2629389 5.77197266,12.3825684 L5.54211428,12.559021 L5.30371094,12.7294922 C5.19433539,12.8069665 5.08894907,12.8838701 4.98754883,12.9602051 C4.88614858,13.0365401 4.79671263,13.1117347 4.71923828,13.185791 C4.64176394,13.2598474 4.58024111,13.3321937 4.53466797,13.402832 C4.48909482,13.4734704 4.46630859,13.5406898 4.46630859,13.6044922 L6.54443359,13.6044922 L6.54443359,14.5 L3.28369141,14.5 L3.28369141,14.1308594 C3.28369141,13.8802071 3.32584593,13.6551931 3.41015625,13.4558105 C3.49446657,13.256428 3.60042254,13.0775561 3.72802734,12.9191895 C3.85563215,12.7608228 3.99519781,12.6206875 4.14672852,12.4987793 C4.24774899,12.4175072 4.3454771,12.3415527 4.43991414,12.2709148 L4.57910156,12.1689453 C4.72265697,12.0664057 4.84855089,11.9684249 4.95678711,11.875 C5.06502333,11.7815751 5.15616825,11.6887212 5.23022461,11.5964355 C5.30428097,11.5041499 5.35953758,11.4107264 5.39599609,11.3161621 C5.43245461,11.2215978 5.45068359,11.1207688 5.45068359,11.0136719 C5.45068359,10.8040354 5.39143939,10.6456711 5.27294922,10.5385742 C5.15445904,10.4314773 4.97330851,10.3779297 4.72949219,10.3779297 C4.3079406,10.3779297 3.90462432,10.5454085 3.51953125,10.8803711 L3.51953125,9.93017578 C3.94564015,9.65445826 4.42642961,9.51660156 4.96191406,9.51660156 Z M19.75,11.4936616 C20.1642136,11.4936616 20.5,11.829448 20.5,12.2436616 C20.5,12.6578751 20.1642136,12.9936616 19.75,12.9936616 L10.75,12.9936616 C10.3357864,12.9936616 10,12.6578751 10,12.2436616 C10,11.829448 10.3357864,11.4936616 10.75,11.4936616 L19.75,11.4936616 Z M5.69488988,2.98925781 L5.69488988,8 L4.61822972,8 L4.61822972,4.20605469 C4.55898463,4.2584638 4.48891697,4.30802385 4.40802464,4.35473633 C4.32713231,4.4014488 4.24111429,4.44360333 4.149968,4.48120117 C4.05882171,4.51879902 3.96425886,4.55069974 3.8662766,4.5769043 C3.76829433,4.60310885 3.67145286,4.6219075 3.57574925,4.63330078 L3.57574925,3.72412109 C3.85602409,3.64208943 4.12034436,3.53727277 4.368718,3.40966797 C4.61709164,3.28206316 4.84153601,3.14192785 5.04205785,2.98925781 L5.69488988,2.98925781 Z M19.75,5 C20.1642136,5 20.5,5.33578644 20.5,5.75 C20.5,6.16421356 20.1642136,6.5 19.75,6.5 L10.75,6.5 C10.3357864,6.5 10,6.16421356 10,5.75 C10,5.33578644 10.3357864,5 10.75,5 L19.75,5 Z"
                                id="🎨-Color"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'bold':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-System-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_text_bold_24_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M12.38,4.00006 C15.0166,4.00006 17,6.18217 17,8.62546 C17,9.6021 16.6833,10.5368 16.1346,11.307 C17.2115,12.1341 18,13.4275 18,15.1201 C18,18.2315 15.3015,20.0001 13.12,20.0001 L8,20.0001 C7.17157,20.0001 6.5,19.3285 6.5,18.5001 L6.49658977,5.50088 C6.49637,5.10291 6.65431,4.72117 6.93564,4.43969 C7.21697,4.15821 7.59862,4.00006 7.99658977,4.00006 L12.38,4.00006 Z M13.12,13.25 L9.5,13.25 L9.5,17.0001 L13.12,17.0001 C13.9931,17.0001 15,16.2465 15,15.1201 C15,13.9902 14.0253,13.25 13.12,13.25 L13.12,13.25 Z M12.38,7.00006 L9.49741,7.00006 L9.49918,10.25 L12.38,10.25 C13.2829,10.25 14,9.49057 14,8.62546 C14,7.76006 13.2819,7.00006 12.38,7.00006 Z"
                                id="Shape"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'italic':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-System-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_text_italic_24_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M9.75,4 L18.2535371,4 C18.6674911,4 19.003067,4.33564847 19.003067,4.74969185 C19.003067,5.12923161 18.72109,5.44289788 18.3552439,5.4925399 L18.2535371,5.4993837 L15.056067,5.499 L10.036067,18.5 L14.2488227,18.5 C14.6282805,18.5 14.941879,18.7822969 14.9915103,19.1482652 L14.9983526,19.25 C14.9983526,19.6295398 14.7163756,19.943465 14.3505295,19.9931501 L14.2488227,20 L4.74953181,20 C4.33557788,20 4.00306702,19.6640434 4.00306702,19.25 C4.00306702,18.8704602 4.28246851,18.556535 4.64788535,18.5068499 L4.74953181,18.5 L8.43406702,18.5 L8.45532362,18.4348625 L13.449067,5.499 L9.75,5.4993837 C9.37054224,5.4993837 9.05654871,5.21734575 9.00685157,4.85142059 L9,4.74969185 C9,4.37015209 9.28237205,4.05648582 9.64828398,4.0068438 L9.75,4 L18.2535371,4 L9.75,4 Z"
                                id="🎨-Color"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'underline':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-Product-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_text_underline_24_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M6.7499467,19 L17.2499467,19 C17.6641603,19 17.9999467,19.3357864 17.9999467,19.75 C17.9999467,20.1296958 17.7177928,20.443491 17.3517173,20.4931534 L17.2499467,20.5 L6.7499467,20.5 C6.33573313,20.5 5.9999467,20.1642136 5.9999467,19.75 C5.9999467,19.3703042 6.28210058,19.056509 6.64817614,19.0068466 L6.7499467,19 L17.2499467,19 L6.7499467,19 Z M17.2499467,4 C17.6296425,4 17.943432,4.28215388 17.9930935,4.64822944 L17.9999399,4.75 L17.9999399,10.75 C17.9999399,15.14367 15.937012,17.5 11.9970286,17.5 C8.14235118,17.5 6.08613334,15.2445515 6.00258542,11.0336223 L5.99993994,10.75 L5.99993994,4.75 C5.99993994,4.33578644 6.33573313,4 6.7499467,4 C7.12964246,4 7.44343198,4.28215388 7.49309346,4.64822944 L7.49993994,4.75 L7.49993994,10.7507362 C7.49640664,14.3568045 8.93340355,16 11.9970286,16 C14.9823743,16 16.4250766,14.4395401 16.4970985,11.0235443 L16.4999399,10.75 L16.4999399,4.75 C16.4999399,4.33578644 16.8357331,4 17.2499467,4 Z"
                                id="🎨-Color"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'link':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 48 48"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g
                        id="🔍-Product-Icons"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                    >
                        <g
                            id="ic_fluent_link_48_regular"
                            fill="#212121"
                            fillRule="nonzero"
                        >
                            <path
                                fill={color}
                                d="M34,14 C39.5228475,14 44,18.4771525 44,24 C44,29.4292399 39.6733292,33.8479317 34.2799048,33.9961582 L34,34 L28.25,34 C27.5596441,34 27,33.4403559 27,32.75 C27,32.1027913 27.4918747,31.5704661 28.1221948,31.5064536 L28.25,31.5 L34,31.5 C38.1421356,31.5 41.5,28.1421356 41.5,24 C41.5,19.9390827 38.2725256,16.6319825 34.2427311,16.5038536 L34,16.5 L28.25,16.5 C27.5596441,16.5 27,15.9403559 27,15.25 C27,14.6027913 27.4918747,14.0704661 28.1221948,14.0064536 L28.25,14 L34,14 Z M19.75,14 C20.4403559,14 21,14.5596441 21,15.25 C21,15.8972087 20.5081253,16.4295339 19.8778052,16.4935464 L19.75,16.5 L14,16.5 C9.85786438,16.5 6.5,19.8578644 6.5,24 C6.5,28.0609173 9.72747441,31.3680175 13.7572689,31.4961464 L14,31.5 L19.75,31.5 C20.4403559,31.5 21,32.0596441 21,32.75 C21,33.3972087 20.5081253,33.9295339 19.8778052,33.9935464 L19.75,34 L14,34 C8.4771525,34 4,29.5228475 4,24 C4,18.5707601 8.32667079,14.1520683 13.7200952,14.0038418 L14,14 L19.75,14 Z M13,22.75 L35,22.75 C35.6903559,22.75 36.25,23.3096441 36.25,24 C36.25,24.6472087 35.7581253,25.1795339 35.1278052,25.2435464 L35,25.25 L13,25.25 C12.3096441,25.25 11.75,24.6903559 11.75,24 C11.75,23.3527913 12.2418747,22.8204661 12.8721948,22.7564536 L13,22.75 L35,22.75 L13,22.75 Z"
                                id="🎨-Color"
                            ></path>
                        </g>
                    </g>
                </svg>
            )
        case 'code':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M13.3252 3.05011L8.66765 20.4323L10.5995 20.9499L15.257 3.56775L13.3252 3.05011Z"
                        fill="#000000"
                    />
                    <path
                        d="M7.61222 18.3608L8.97161 16.9124L8.9711 16.8933L3.87681 12.1121L8.66724 7.00798L7.20892 5.63928L1.0498 12.2017L7.61222 18.3608Z"
                        fill="#000000"
                    />
                    <path
                        d="M16.3883 18.3608L15.0289 16.9124L15.0294 16.8933L20.1237 12.1121L15.3333 7.00798L16.7916 5.63928L22.9507 12.2017L16.3883 18.3608Z"
                        fill="#000000"
                    />
                </svg>
            )
        case 'collapse':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 48 48"
                    fill={color || 'black'}
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g id="Layer_2" data-name="Layer 2">
                        <g id="invisible_box" data-name="invisible box">
                            <rect width="48" height="48" fill="none" />
                        </g>
                        <g id="icons_Q2" data-name="icons Q2">
                            <g>
                                <path d="M22.6,15.4a1.9,1.9,0,0,0,2.8,0l6-5.9a2.1,2.1,0,0,0,.2-2.7,1.9,1.9,0,0,0-3-.2L26,9.2V4a2,2,0,0,0-4,0V9.2L19.4,6.6a1.9,1.9,0,0,0-3,.2,2.1,2.1,0,0,0,.2,2.7Z" />
                                <path d="M25.4,32.6a1.9,1.9,0,0,0-2.8,0l-6,5.9a2.1,2.1,0,0,0-.2,2.7,1.9,1.9,0,0,0,3,.2L22,38.8V44a2,2,0,0,0,4,0V38.8l2.6,2.6a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7Z" />
                                <path d="M6,22H42a2,2,0,0,0,0-4H6a2,2,0,0,0,0,4Z" />
                                <path d="M42,26H6a2,2,0,0,0,0,4H42a2,2,0,0,0,0-4Z" />
                            </g>
                        </g>
                    </g>
                </svg>
            )
        case 'inline-content':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M22 18L2 18"
                        stroke={color || '#000'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M22 2L2 2"
                        stroke={color || '#000'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M3.5 14L20.5 14C21.3284 14 22 13.3284 22 12.5V7.5C22 6.67157 21.3284 6 20.5 6L3.5 6C2.67157 6 2 6.67157 2 7.5L2 12.5C2 13.3284 2.67157 14 3.5 14Z"
                        stroke={color || '#000'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M14 22L2 22"
                        stroke={color || '#000'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'review-stars':
            return (
                <svg
                    width={width}
                    height={height}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.36655 10.2421C4.28985 8.4221 3.75151 7.51211 4.11106 6.78804C4.4706 6.06397 5.48992 6.00535 7.52857 5.88812L8.05599 5.85779C8.63531 5.82448 8.92497 5.80782 9.17756 5.67305C9.43014 5.53828 9.61705 5.30066 9.99088 4.82542L10.3312 4.39274C11.6467 2.72034 12.3045 1.88413 13.0606 2.01293C13.8167 2.14173 14.1705 3.15023 14.8779 5.16723M5.80455 13.5087C5.25206 15.5982 4.97582 16.6429 5.50972 17.2192C6.04363 17.7955 7.0341 17.5217 9.01504 16.9741L9.99088 16.5M17.048 7.50967C18.9378 8.29605 19.8826 8.68925 19.9904 9.49292C20.0823 10.1786 19.513 10.7756 18.3493 11.7831"
                        stroke={color || '#1C274C'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                    <path
                        d="M16.2387 19.57C17.7244 19.9565 18.4673 20.1498 18.8677 19.743C19.2681 19.3362 19.061 18.5987 18.6466 17.1238L18.5394 16.7422C18.4216 16.3231 18.3628 16.1135 18.3924 15.9057C18.422 15.6979 18.5367 15.5154 18.7662 15.1503L18.9751 14.818C19.7826 13.5332 20.1864 12.8909 19.9167 12.3798C19.647 11.8687 18.8826 11.8273 17.3536 11.7446L16.958 11.7231C16.5235 11.6996 16.3063 11.6879 16.1168 11.5927C15.9274 11.4976 15.7872 11.3299 15.5068 10.9944L15.2516 10.689C14.265 9.50847 13.7716 8.91821 13.2045 9.00913C12.6375 9.10004 12.3722 9.81193 11.8416 11.2357L11.7043 11.604C11.5535 12.0086 11.4781 12.2109 11.3314 12.3599C11.1848 12.509 10.9834 12.5878 10.5806 12.7456L10.214 12.8892C8.79667 13.4443 8.08803 13.7218 8.00721 14.2891C7.92639 14.8564 8.52692 15.3378 9.72797 16.3004L10.0387 16.5495C10.38 16.8231 10.5507 16.9599 10.6494 17.1471C10.7482 17.3343 10.7639 17.5508 10.7954 17.9837L10.824 18.3779C10.9347 19.9015 10.9901 20.6633 11.5072 20.923C12.0244 21.1827 12.6608 20.7683 13.9337 19.9395"
                        stroke={color || '#1C274C'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                    />
                </svg>
            )
        case 'plp-grid':
            return (
                <svg
                    fill={color || '#000000'}
                    width={width}
                    height={height}
                    viewBox="0 0 32 32"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M30 32h-10c-1.105 0-2-0.895-2-2v-10c0-1.105 0.895-2 2-2h10c1.105 0 2 0.895 2 2v10c0 1.105-0.895 2-2 2zM30 20h-10v10h10v-10zM30 14h-10c-1.105 0-2-0.896-2-2v-10c0-1.105 0.895-2 2-2h10c1.105 0 2 0.895 2 2v10c0 1.104-0.895 2-2 2zM30 2h-10v10h10v-10zM12 32h-10c-1.105 0-2-0.895-2-2v-10c0-1.105 0.895-2 2-2h10c1.104 0 2 0.895 2 2v10c0 1.105-0.896 2-2 2zM12 20h-10v10h10v-10zM12 14h-10c-1.105 0-2-0.896-2-2v-10c0-1.105 0.895-2 2-2h10c1.104 0 2 0.895 2 2v10c0 1.104-0.896 2-2 2zM12 2h-10v10h10v-10z"></path>
                </svg>
            )
        case 'personalized-plp-grid':
            return (
                <svg
                    fill="none"
                    width={width}
                    height={height}
                    viewBox="0 0 32 32"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_1_49)">
                        <path
                            d="M30 32H20C18.895 32 18 31.105 18 30V20C18 18.895 18.895 18 20 18H30C31.105 18 32 18.895 32 20V30C32 31.105 31.105 32 30 32ZM30 20H20V30H30V20ZM12 32H2C0.895 32 0 31.105 0 30V20C0 18.895 0.895 18 2 18H12C13.104 18 14 18.895 14 20V30C14 31.105 13.104 32 12 32ZM12 20H2V30H12V20ZM12 14H2C0.895 14 0 13.104 0 12V2C0 0.895 0.895 0 2 0H12C13.104 0 14 0.895 14 2V12C14 13.104 13.104 14 12 14ZM12 2H2V12H12V2Z"
                            fill={color || 'black'}
                        />
                        <path
                            d="M18 10.3889V4.61111C18 3.65338 18.3805 2.73488 19.0577 2.05767C19.7349 1.38046 20.6534 1 21.6111 1H27.3889C28.3466 1 29.2651 1.38046 29.9423 2.05767C30.6195 2.73488 31 3.65338 31 4.61111V10.3889C31 11.3466 30.6195 12.2651 29.9423 12.9423C29.2651 13.6195 28.3466 14 27.3889 14H21.6111C20.6534 14 19.7349 13.6195 19.0577 12.9423C18.3805 12.2651 18 11.3466 18 10.3889Z"
                            stroke={color || 'black'}
                            strokeWidth="1.5"
                        />
                        <path
                            d="M27.75 9.30554C27.75 9.30554 26.6667 10.75 24.5 10.75C22.3333 10.75 21.25 9.30554 21.25 9.30554"
                            stroke={color || 'black'}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M21.9722 6.05557C21.8765 6.05557 21.7846 6.01752 21.7169 5.9498C21.6492 5.88208 21.6111 5.79023 21.6111 5.69445C21.6111 5.59868 21.6492 5.50683 21.7169 5.43911C21.7846 5.37139 21.8765 5.33334 21.9722 5.33334C22.068 5.33334 22.1598 5.37139 22.2276 5.43911C22.2953 5.50683 22.3333 5.59868 22.3333 5.69445C22.3333 5.79023 22.2953 5.88208 22.2276 5.9498C22.1598 6.01752 22.068 6.05557 21.9722 6.05557ZM27.0278 6.05557C26.932 6.05557 26.8402 6.01752 26.7724 5.9498C26.7047 5.88208 26.6667 5.79023 26.6667 5.69445C26.6667 5.59868 26.7047 5.50683 26.7724 5.43911C26.8402 5.37139 26.932 5.33334 27.0278 5.33334C27.1236 5.33334 27.2154 5.37139 27.2831 5.43911C27.3508 5.50683 27.3889 5.59868 27.3889 5.69445C27.3889 5.79023 27.3508 5.88208 27.2831 5.9498C27.2154 6.01752 27.1236 6.05557 27.0278 6.05557Z"
                            fill={color || 'black'}
                            stroke={color || 'black'}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    {/* <defs>
                        <clipPath id="clip0_1_49">
                            <rect
                                width={width}
                                height={height}
                                fill="white"
                            />
                        </clipPath>
                    </defs>*/}
                </svg>
            )
        case 'configure-experiment':
            return (
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M24 2V7M24 41V46M8.44 8.44L11.28 11.28M36.72 36.72L39.56 39.56M2 24H7M41 24H46M8.44 39.56L11.28 36.72M36.72 11.28L39.56 8.44"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <rect
                        x="6"
                        y="14"
                        width="15"
                        height="10"
                        rx="1"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M21 18H6M6 16.8L6 24.2C6 26.88 6 27.72 6.327 28.36C6.615 28.93 7.073 29.39 7.638 29.67C8.28 30 9.12 30 10.8 30H19.2C20.88 30 21.72 30 22.36 29.67C22.927 29.39 23.39 28.93 23.67 28.36C24 27.72 24 26.88 24 24.2V16.8"
                        stroke={color || '#000'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <rect
                        x="27"
                        y="14"
                        width="15"
                        height="10"
                        rx="1"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M42 18H27M27 16.8L27 24.2C27 26.88 27 27.72 27.327 28.36C27.615 28.93 28.073 29.39 28.638 29.67C29.28 30 30.12 30 31.8 30H40.2C41.88 30 42.72 30 43.36 29.67C43.927 29.39 44.39 28.93 44.67 28.36C45 27.72 45 26.88 45 24.2V16.8"
                        stroke={color || '#000'}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M19 35L29 35M24 33V37"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'support-center':
            return (
                <svg
                    width={width || '20'}
                    height={height || '20'}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {/* Left page with curve */}
                    <path
                        d="M2 6C2 4.89543 2.89543 4 4 4H10C11.1046 4 12 4.89543 12 6V18C12 16.8954 11.1046 16 10 16H4C2.89543 16 2 16.8954 2 18V6Z"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    {/* Right page with curve */}
                    <path
                        d="M22 6C22 4.89543 21.1046 4 20 4H14C12.8954 4 12 4.89543 12 6V18C12 16.8954 12.8954 16 14 16H20C21.1046 16 22 16.8954 22 18V6Z"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    {/* Left page lines */}
                    <path
                        d="M5 8H9"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M5 11H9"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    {/* Right page lines */}
                    <path
                        d="M15 8H19"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M15 11H19"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    {/* Bottom curve of pages */}
                    <path
                        d="M2 18C2 19.1046 2.89543 20 4 20H10C11.1046 20 12 19.1046 12 18"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M22 18C22 19.1046 21.1046 20 20 20H14C12.8954 20 12 19.1046 12 18"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            )
        case 'post-click-explorer':
            return (
                <svg
                    width={width || '20'}
                    height={height || '20'}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12 4V20"
                        stroke={color || '#000'}
                        strokeWidth="2"
                    />
                    <path
                        d="M4 14V18"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M8 10V18"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M16 12V18"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M20 8V18"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                    <path
                        d="M3 20H21"
                        stroke={color || '#000'}
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            )
        case 'house':
            return (
                <svg
                    width={width || 14}
                    height={height || 14}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M2 11L12 3L22 11V21H2V11Z"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                    />
                    <path
                        d="M9 22V14h6v8"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'email':
            return (
                <svg
                    width={width || 14}
                    height={height || 14}
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M30.5 29h-29c-.276 0-.5-.224-.5-.5v-16c0-.276.224-.5.5-.5s.5.224.5.5V28h28V8.5c0-.276.224-.5.5-.5s.5.224.5.5v20c0 .276-.224.5-.5.5z"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                    />
                    <path
                        d="M1.5 27a.497.497 0 01-.398-.198.501.501 0 01.097-.7l8.884-6.74a.5.5 0 01.7.097.501.501 0 01-.097.7l-8.884 6.74a.495.495 0 01-.302.101z"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                    />
                    <path
                        d="M30.5 27a.495.495 0 01-.302-.102l-8.935-6.779a.501.501 0 01-.097-.7.502.502 0 01.7-.097l8.935 6.779a.501.501 0 01.097.7.497.497 0 01-.398.199z"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                    />
                    <path
                        d="M16 21.253c-.698 0-1.358-.229-1.859-.643L2.723 11.16C1.757 10.362 1 8.974 1 8V6.5c0-.276.224-.5.5-.5h29c.276 0 .5.224.5.5V8c0 .974-.757 2.362-1.723 3.161l-11.418 9.448c-.501.415-1.161.644-1.859.644zM2 7v1c0 .675.636 1.791 1.359 2.39l11.418 9.45c.645.531 1.801.532 2.445-.001l11.418-9.448C29.364 9.791 30 8.675 30 8V7H2z"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        fill="none"
                    />
                </svg>
            )
        case 'advertising':
            return (
                <svg
                    width={width || 14}
                    height={height || 14}
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M23.5 17.092V13H20.5V12H23.5V14.658L25.858 11.689C25.953 11.569 26.098 11.5 26.25 11.5H29V2.5H14V11.5H16.5V12.5H14.5C13.673 12.5 13 11.827 13 11V2.5C13 1.673 13.673 1 14.5 1H29.5C30.327 1 31 1.673 31 2.5V11.5C31 12.327 30.327 13 29.5 13H26.991L23.891 16.902"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M18.5 18V19C19.603 19 20.5 19.897 20.5 21C20.5 22.103 19.603 23 18.5 23V24"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M6.927 24.563L7.412 29.698L5.893 30.003L5.865 30.03L5.026 24.562H4.016L4.889 30.235C5.009 30.686 5.421 31.002 5.891 31.002C5.956 31.002 6.023 30.996 6.089 30.982L7.608 30.677C7.872 30.625 8.097 30.473 8.244 30.249C8.391 30.025 8.441 29.758 8.394 29.553L7.929 24.562"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8.5 17.5C11.056 17.5 13.722 16.53 16.209 14.694"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M18.5 29.5C18.365 29.5 18.229 29.445 18.131 29.337C18.09 29.293 13.994 24.889 8.463 24.889H3.375C2.11 24.889 1 23.774 1 22.502V19.25C1 17.97 2.088 16.889 3.375 16.889L6.5 16.889"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M8 17.537V24.455"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M18.5 12.5V29.5"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M3.5 21.5H4.5"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M3.5 19.5H4.5"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M19 3.5L25 10.5"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M24.5 8.5C24.5 9.5 24.5 10.5 24.5 10.5C24.5 10.5 25.5 10.5 26 9.5C26.5 8.5 24.5 8.5 24.5 8.5Z"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M19.5 4.5C19.5 5.5 19.5 6.5 19.5 6.5C19.5 6.5 20.5 6.5 21 5.5C21.5 4.5 19.5 4.5 19.5 4.5Z"
                        stroke={color || 'currentColor'}
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'square-logo':
            return (
                <svg
                    width={width || 130}
                    height={height}
                    viewBox="0 0 133.998 21.055"
                    overflow="visible"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g fill={color || '#1c1c1c'}>
                        <path d="M 12.254 10.446 C 11.054 10.105 7.842 8.468 7.624 1.75 C 7.593 0.798 6.852 0 5.915 0 L 0.118 0 C 0.118 0 -1.048 5.514 3.951 8.343 C 6.057 9.536 7.793 9.788 7.793 10.527 C 7.793 11.266 6.057 11.519 3.951 12.711 C -1.048 15.542 0.118 21.055 0.118 21.055 L 5.915 21.055 C 6.852 21.055 7.593 20.258 7.624 19.305 C 7.842 12.588 11.054 10.951 12.254 10.61 C 12.289 10.599 12.314 10.565 12.314 10.527 C 12.314 10.489 12.289 10.456 12.254 10.445 Z M 126.885 7.896 L 128.62 3.312 L 128.789 2.846 L 129.943 2.846 L 131.862 7.951 L 132.153 8.728 L 130.861 8.728 L 130.608 7.951 L 130.417 7.376 L 128.246 7.376 L 128.055 7.943 L 127.795 8.728 L 126.572 8.728 Z M 130.142 6.537 L 129.339 4.136 L 128.529 6.537 Z M 132.79 7.586 L 132.79 2.846 L 133.998 2.846 L 133.998 8.728 L 132.79 8.728 L 132.79 7.586 Z M 35.761 18.527 L 35.761 18.446 C 35.061 17.956 34.962 17.244 34.962 15.799 L 34.962 5.343 C 34.962 3.733 35.003 3.267 35.103 2.653 L 35.081 2.573 L 32.18 2.919 L 32.18 3 C 32.78 3.469 32.922 4.118 32.922 5.343 L 32.922 15.795 C 32.922 17.243 32.823 17.956 32.082 18.443 L 32.082 18.527 L 35.761 18.527 Z" />
                        <path d="M 39.959 18.793 L 39.961 18.8 C 38.262 18.797 37.046 17.918 37.046 16.169 C 37.046 14.315 38.467 13.644 40.947 12.909 L 40.985 12.899 C 42.837 12.358 43.766 12.086 43.785 10.791 C 43.785 9.709 43.078 9.139 41.883 9.139 C 40.688 9.139 39.906 9.751 39.732 11.234 C 39.694 11.56 39.437 11.827 39.113 11.827 L 37.197 11.827 C 37.356 9.464 39.68 8.201 42.06 8.201 C 44.12 8.201 45.761 9.096 45.761 11.561 L 45.761 15.981 C 45.761 17.123 46.102 17.57 46.702 17.57 C 46.983 17.57 47.203 17.486 47.424 17.304 C 47.424 17.304 47.329 18.69 45.802 18.69 C 44.925 18.69 44.209 18.075 44.209 17.026 C 44.209 16.866 44.099 16.781 43.967 16.772 C 43.873 16.764 43.784 16.812 43.73 16.893 C 42.901 18.168 41.932 18.792 39.959 18.792 Z M 39.967 18.8 L 39.961 18.8 L 39.961 18.8 C 39.963 18.8 39.965 18.8 39.967 18.8 Z M 39.017 15.899 L 39.017 15.901 L 39.018 15.901 C 39.018 17.02 39.74 17.489 40.6 17.489 C 42.479 17.489 43.781 15.776 43.781 13.332 L 43.781 12.374 C 43.5 13.026 42.678 13.31 41.46 13.719 C 39.86 14.247 39.018 14.696 39.018 15.897 Z" />
                        <path d="M 52.775 18.85 C 55.655 18.85 57.315 16.933 57.675 14.43 L 56.577 14.43 C 56.216 16.244 55.174 17.587 53.235 17.587 C 50.914 17.587 50.048 15.612 50.048 13.227 C 50.048 10.841 50.914 9.152 52.974 9.152 C 54.627 9.152 55.368 10.284 55.674 11.484 C 55.745 11.768 55.988 11.984 56.277 11.984 L 57.596 11.984 C 57.315 9.886 55.634 8.193 52.934 8.193 C 50.032 8.193 47.682 10.149 47.682 13.531 C 47.682 16.913 49.913 18.849 52.772 18.849 L 52.775 18.849 Z M 82.058 18.791 C 86.28 18.791 89.06 16.143 89.681 11.964 L 88.379 11.964 C 87.839 15.164 85.739 17.283 82.477 17.283 C 78.655 17.283 76.889 14.269 76.889 10.559 C 76.889 6.849 78.815 3.936 82.237 3.936 C 84.745 3.936 86.507 5.493 87.221 7.976 C 87.297 8.245 87.534 8.439 87.809 8.439 L 89.54 8.439 C 88.681 4.71 85.8 2.858 82.237 2.858 C 77.593 2.858 74.265 6.058 74.265 10.846 C 74.265 15.287 77.213 18.792 82.055 18.792 L 82.056 18.792 L 82.056 18.794 Z" />
                        <path d="M 98.177 13.52 C 98.177 10.319 100.284 8.201 103.447 8.201 C 106.61 8.201 108.717 10.344 108.717 13.52 C 108.717 16.695 106.608 18.855 103.447 18.855 C 100.302 18.855 98.177 16.72 98.177 13.52 Z M 103.467 17.902 C 105.407 17.902 106.48 16.292 106.48 13.52 C 106.48 10.748 105.447 9.159 103.467 9.159 C 101.486 9.159 100.412 10.749 100.412 13.52 C 100.412 16.273 101.526 17.902 103.467 17.902 Z" />
                        <path d="M 110.142 10.524 L 112.922 18.532 L 114.458 18.532 C 114.499 18.206 114.579 17.942 114.756 17.393 L 116.617 11.341 L 118.875 18.536 L 120.388 18.536 C 120.425 18.233 120.506 17.989 120.62 17.647 L 120.642 17.582 L 120.66 17.531 L 120.671 17.497 L 123.111 10.467 C 123.45 9.448 123.771 8.959 124.251 8.634 L 124.251 8.574 L 121.554 8.574 L 121.554 8.634 C 122.154 8.858 122.113 9.449 121.774 10.45 L 119.891 16.196 L 117.631 8.982 L 116.472 8.982 L 114.272 16.177 L 112.351 10.411 C 112.032 9.431 111.99 8.883 112.593 8.639 L 112.593 8.578 L 108.936 8.578 L 108.936 8.639 C 109.476 8.905 109.757 9.516 110.138 10.535 L 110.138 10.526 Z" />
                        <path d="M 27.788 10.386 C 29.677 10.911 30.971 12.258 30.971 14.193 C 30.971 17.185 28.254 18.531 24.455 18.531 L 19.073 18.531 L 19.073 18.451 C 19.854 17.965 19.953 17.25 19.953 15.803 L 19.953 5.835 C 19.953 4.307 19.852 3.678 19.073 3.167 L 19.073 3.107 L 24.332 3.107 C 27.715 3.107 30.212 4.145 30.212 6.611 C 30.212 8.264 29.451 9.101 27.746 9.742 C 27.626 9.782 27.451 9.86 27.451 10.068 C 27.451 10.301 27.674 10.355 27.767 10.379 C 27.776 10.38 27.79 10.385 27.79 10.385 Z M 24.154 4.106 L 22.129 4.106 L 22.129 9.876 L 24.11 9.876 C 26.312 9.876 27.854 8.689 27.854 6.754 C 27.854 4.819 26.354 4.107 24.154 4.107 Z M 24.314 17.534 L 24.312 17.534 L 24.312 17.535 L 24.314 17.535 Z M 24.312 17.534 L 24.312 17.533 L 24.311 17.533 C 26.772 17.533 28.493 16.639 28.493 14.131 C 28.493 11.807 26.855 10.648 24.152 10.648 L 22.132 10.648 L 22.132 17.534 Z" />
                        <path d="M 93.323 11.334 C 93.416 11.349 93.504 11.304 93.533 11.214 L 93.541 11.213 C 94.11 9.538 95.402 8.497 97.783 8.475 L 97.783 9.814 C 97.783 10.154 97.505 10.422 97.17 10.436 C 94.753 10.539 93.741 11.835 93.741 13.59 L 93.741 15.913 C 93.741 17.34 93.841 18.011 94.621 18.502 L 94.621 18.563 L 90.878 18.563 L 90.878 18.482 C 91.578 17.994 91.698 17.281 91.698 15.834 L 91.698 11.331 C 91.698 9.802 91.578 9.174 90.878 8.663 L 90.878 8.601 L 94.019 8.601 C 93.961 8.73 93.882 8.855 93.793 8.992 C 93.515 9.425 93.159 9.984 93.159 11.143 C 93.153 11.236 93.223 11.318 93.323 11.334 Z M 65.022 13.873 C 64.645 13.747 64.426 13.682 64.426 13.482 C 64.426 13.263 64.644 13.191 65.024 13.025 C 66.139 12.539 67.421 11.632 67.421 9.491 C 67.421 8.855 67.366 8.39 67.366 8.39 L 65.759 8.39 C 65.406 8.39 65.113 8.678 65.113 9.037 C 65.113 9.573 65.083 9.978 65.071 10.193 C 64.966 11.988 63.583 13.093 61.688 13.093 L 61.688 5.38 C 61.688 3.769 61.73 3.282 61.829 2.67 L 61.688 2.609 L 58.969 2.956 L 58.969 3.036 C 59.549 3.505 59.649 4.139 59.649 5.38 L 59.649 15.831 C 59.649 17.278 59.549 17.991 58.808 18.478 L 58.808 18.559 L 62.509 18.559 C 61.788 18.07 61.688 17.276 61.688 15.832 L 61.688 13.922 C 64.006 13.922 65.695 15.383 65.899 17.516 C 65.971 18.255 66.022 18.574 66.758 18.574 L 68.234 18.574 C 68.234 18.574 68.3 18.058 68.3 17.671 C 68.3 15.267 66.196 14.262 65.022 13.876 L 65.022 13.872 Z" />
                    </g>
                </svg>
            )
        case 'crow-icon':
            return (
                <svg
                    width={width || 24}
                    height={height || 24}
                    viewBox="-1.1 0 13.5 21.1"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill={color || '#1c1c1c'}
                        d="M 12.254 10.446 C 11.054 10.105 7.842 8.468 7.624 1.75 C 7.593 0.798 6.852 0 5.915 0 L 0.118 0 C 0.118 0 -1.048 5.514 3.951 8.343 C 6.057 9.536 7.793 9.788 7.793 10.527 C 7.793 11.266 6.057 11.519 3.951 12.711 C -1.048 15.542 0.118 21.055 0.118 21.055 L 5.915 21.055 C 6.852 21.055 7.593 20.258 7.624 19.305 C 7.842 12.588 11.054 10.951 12.254 10.61 C 12.289 10.599 12.314 10.565 12.314 10.527 C 12.314 10.489 12.289 10.456 12.254 10.445 Z"
                    />
                </svg>
            )
        case 'credit-card':
            return (
                <svg
                    width={width || 24}
                    height={height || 24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z"
                        stroke={color || 'black'}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M2 10H22"
                        stroke={color || 'black'}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            )
        case 'google':
            return (
                <svg
                    width={width || 24}
                    height={height || 24}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                        fill="#4285F4"
                    />
                    <path
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                        fill="#34A853"
                    />
                    <path
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                        fill="#FBBC05"
                    />
                    <path
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                        fill="#EA4335"
                    />
                </svg>
            )
        default:
            return null
    }
}
